import React, { useState, useEffect } from "react";
import {
    Printer,
    Settings,
    FileCheck,
    Phone,
    Mail,
    ArrowRight,
    Check,
    Menu,
    X,
    Sun,
    Moon,
    Cpu,
    Zap,
    Layers,
    Shield,
    Activity,
    Plus,
    Minus,
    Filter,
    Calculator,
    Sparkles,
    CheckCircle2,
    Cookie,
    ChevronDown,
} from "lucide-react";

const FacebookIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
    </svg>
);

const InstagramIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
);

const LinkedinIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
    >
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
        <rect x="2" y="9" width="4" height="12"></rect>
        <circle cx="4" cy="4" r="2"></circle>
    </svg>
);

const BrandLogo = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        className={className}
        aria-hidden="true"
    >
        <path d="M10 90 L35 10 L85 10 L60 90 Z" fill="#2563eb" />
        <path d="M10 90 L35 10 L55 10 L30 90 Z" fill="#f97316" />
        <path d="M45 40 L100 40 L85 65 L30 65 Z" fill="#38bdf8" />
        <path
            d="M60 10 L85 10 L75 40 L50 40 Z"
            fill="#ffffff"
            fillOpacity="0.2"
        />
    </svg>
);

const devicesDB = [
    {
        id: 1,
        vendor: "Konica Minolta",
        model: "Bizhub C251i",
        kind: "MFP",
        type: "KOLOR",
        format: "A3",
        lease: 199,
        clickMono: 3,
        clickColor: 18,
        specs: {
            speed: "25 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "8 GB RAM / 256 GB SSD",
            paper: "2x 500 arkuszy + 150 ręczny",
            panel: '10.1" tabletowy ekran dotykowy',
            extra: "Opcjonalny skaner jednoprzebiegowy (DualScan)",
        },
    },
    {
        id: 2,
        vendor: "Konica Minolta",
        model: "Bizhub C451i",
        kind: "MFP",
        type: "KOLOR",
        format: "A3",
        lease: 289,
        clickMono: 3,
        clickColor: 15,
        specs: {
            speed: "45 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "8 GB RAM / 256 GB SSD",
            paper: "2x 500 arkuszy + 150 ręczny",
            panel: '10.1" tabletowy ekran dotykowy',
            extra: "Skaner jednoprzebiegowy do 280 obr./min",
        },
    },
    {
        id: 3,
        vendor: "Konica Minolta",
        model: "Bizhub 4221i",
        kind: "MFP",
        type: "MONO",
        format: "A4",
        lease: 39,
        clickMono: 7,
        clickColor: null,
        specs: {
            speed: "42 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "4 GB RAM",
            paper: "1x 500 arkuszy + 100 ręczny",
            panel: '7" ekran dotykowy',
            extra: "Kompaktowa budowa robocza",
        },
    },
    {
        id: 4,
        vendor: "Konica Minolta",
        model: "Bizhub 4201i",
        kind: "Drukarka",
        type: "MONO",
        format: "A4",
        lease: 20,
        clickMono: 7,
        clickColor: null,
        specs: {
            speed: "42 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "512 MB RAM",
            paper: "1x 500 arkuszy + 100 ręczny",
            panel: "Wielowierszowy LCD",
            extra: "Cichy tryb Eco, AirPrint",
        },
    },
    {
        id: 5,
        vendor: "Konica Minolta",
        model: "Bizhub 5001i",
        kind: "Drukarka",
        type: "MONO",
        format: "A4",
        lease: 34,
        clickMono: 5,
        clickColor: null,
        specs: {
            speed: "50 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "512 MB RAM",
            paper: "1x 500 arkuszy + 100 ręczny",
            panel: "Wielowierszowy LCD",
            extra: "Zwiększona wydajność miesięczna",
        },
    },
    {
        id: 6,
        vendor: "Konica Minolta",
        model: "Bizhub 5021i",
        kind: "MFP",
        type: "MONO",
        format: "A4",
        lease: 59,
        clickMono: 5,
        clickColor: null,
        specs: {
            speed: "50 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "4 GB RAM",
            paper: "1x 500 arkuszy + 100 ręczny",
            panel: '7" ekran dotykowy',
            extra: "Zintegrowany system obiegów dokumentów",
        },
    },
    {
        id: 7,
        vendor: "Canon",
        model: "imageRunner C3326i",
        kind: "MFP",
        type: "KOLOR",
        format: "A3",
        lease: 149,
        clickMono: 5,
        clickColor: 30,
        specs: {
            speed: "26 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "2 GB RAM / 64 GB eMMC",
            paper: "2x 550 arkuszy + 100 ręczny",
            panel: '7" kolorowy ekran TFT LCD',
            extra: "Ochrona McAfee Embedded Control",
        },
    },
    {
        id: 8,
        vendor: "Canon",
        model: "imageRunner C3922i",
        kind: "MFP",
        type: "KOLOR",
        format: "A3",
        lease: 199,
        clickMono: 4,
        clickColor: 20,
        specs: {
            speed: "22 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "2 GB RAM / 256 GB SSD (opcja)",
            paper: "2x 550 arkuszy + 100 ręczny",
            panel: '10.1" ekran dotykowy',
            extra: "Zaawansowana integracja z chmurą uniFLOW",
        },
    },
    {
        id: 9,
        vendor: "Canon",
        model: "imageForce C1333",
        kind: "MFP",
        type: "KOLOR",
        format: "A4",
        lease: 39,
        clickMono: 5,
        clickColor: 20,
        specs: {
            speed: "33 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "2 GB RAM",
            paper: "1x 250 arkuszy",
            panel: '5" ekran dotykowy',
            extra: "Skaner jednoprzebiegowy do 100 obr./min",
        },
    },
    {
        id: 10,
        vendor: "Canon",
        model: "imageForce 1440",
        kind: "MFP",
        type: "MONO",
        format: "A4",
        lease: 35,
        clickMono: 4,
        clickColor: null,
        specs: {
            speed: "40 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "2 GB RAM",
            paper: "1x 250 arkuszy",
            panel: '5" ekran dotykowy',
            extra: "Skaner jednoprzebiegowy",
        },
    },
    {
        id: 11,
        vendor: "Canon",
        model: "imageForce C1333 P",
        kind: "Drukarka",
        type: "KOLOR",
        format: "A4",
        lease: 30,
        clickMono: 5,
        clickColor: 20,
        specs: {
            speed: "33 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "1 GB RAM",
            paper: "1x 250 arkuszy",
            panel: "Wielowierszowy LCD",
            extra: "Kompaktowa obudowa",
        },
    },
    {
        id: 12,
        vendor: "Canon",
        model: "imageForce 1440 P",
        kind: "Drukarka",
        type: "MONO",
        format: "A4",
        lease: 29,
        clickMono: 4,
        clickColor: null,
        specs: {
            speed: "40 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "1 GB RAM",
            paper: "1x 250 arkuszy",
            panel: "Wielowierszowy LCD",
            extra: "Wysoka wydajność pierwszej strony",
        },
    },
    {
        id: 13,
        vendor: "Kyocera",
        model: "Ecosys M8124cidn",
        kind: "MFP",
        type: "KOLOR",
        format: "A3",
        lease: 219,
        clickMono: 3,
        clickColor: 20,
        specs: {
            speed: "24 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "1.5 GB RAM",
            paper: "1x 500 arkuszy + 100 ręczny",
            panel: '4.3" ekran dotykowy',
            extra: "Technologia długowiecznych podzespołów ECOSYS",
        },
    },
    {
        id: 14,
        vendor: "Kyocera",
        model: "Ecosys MA5500ifx",
        kind: "MFP",
        type: "MONO",
        format: "A4",
        lease: 94,
        clickMono: 3,
        clickColor: null,
        specs: {
            speed: "55 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "1.5 GB RAM",
            paper: "1x 500 arkuszy + 100 ręczny",
            panel: '7" ekran dotykowy',
            extra: "Podajnik dokumentów na 100 arkuszy z dual-scan",
        },
    },
    {
        id: 15,
        vendor: "Kyocera",
        model: "Ecosys PA4000x",
        kind: "Drukarka",
        type: "MONO",
        format: "A4",
        lease: 19,
        clickMono: 4,
        clickColor: null,
        specs: {
            speed: "40 str./min",
            resolution: "1200 x 1200 dpi",
            memory: "512 MB RAM",
            paper: "1x 250 arkuszy + 100 ręczny",
            panel: "Podświetlany LCD",
            extra: "Bęben ceramiczny na 300 000 stron",
        },
    },
];

const faqs = [
    {
        q: "Jak dokładnie działa rozliczenie za stronę (Click)?",
        a: "Płacisz stałą stawkę groszową wyłącznie za faktycznie wydrukowane strony. W tej kwocie zawarte są wszystkie koszty eksploatacyjne: tonery, bębny, części zamienne, a także regularne przeglądy, praca serwisanta i dojazdy. Płacisz tylko za papier i zasilanie.",
    },
    {
        q: "Czy oprogramowanie SafeQ wymaga własnego serwera?",
        a: "Niekoniecznie. YSoft SafeQ możemy wdrożyć w nowoczesnym modelu chmurowym (Cloud) lub klasycznie on-premise na Twoim serwerze. Architekturę zawsze dopasowujemy do wymogów polityki bezpieczeństwa w Twojej infrastrukturze IT.",
    },
    {
        q: "Co się dzieje, gdy maszyna ulegnie awarii?",
        a: "Nasze umowy gwarantują określony czas reakcji serwisu (SLA). Jeśli technik nie jest w stanie usunąć usterki na miejscu, bezpłatnie dostarczamy urządzenie zastępcze o parametrach nie gorszych niż Twoja maszyna bazowa, by utrzymać ciągłość pracy.",
    },
    {
        q: "Skąd wiecie, że kończy się nam toner?",
        a: "Dzięki bezpiecznemu agentowi telemetrycznemu Princity, maszyny na bieżąco komunikują się z naszym magazynem. Gdy poziom tonera spadnie do poziomu rezerwy, system automatycznie generuje zlecenie wysyłki. Zapas dotrze do Ciebie kurierem, zanim drukarka stanie.",
    },
    {
        q: "Czy audyt środowiska druku jest płatny?",
        a: "Nie, wstępny audyt Twojego parku maszynowego i potrzeb firmy jest całkowicie bezpłatny. Analizujemy obecne wydatki, obciążenia oraz procesy obiegu dokumentów i proponujemy optymalizację bez jakichkolwiek zobowiązań.",
    },
];

export default function App() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isDarkMode, setIsDarkMode] = useState(true);
    const [isContactOpen, setIsContactOpen] = useState(false);
    const [contactContext, setContactContext] = useState(null);
    const [activeFaq, setActiveFaq] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [legalModal, setLegalModal] = useState(null);
    const [introStage, setIntroStage] = useState("loading");

    const [cookieConsent, setCookieConsent] = useState(() => {
        if (typeof window !== "undefined") {
            return localStorage.getItem("cookieConsent") === "true";
        }
        return false;
    });

    const handleAcceptCookies = () => {
        setCookieConsent(true);
        localStorage.setItem("cookieConsent", "true");
    };

    const [formStatus, setFormStatus] = useState("idle");

    const [filterFormat, setFilterFormat] = useState("ALL");
    const [filterType, setFilterType] = useState("ALL");
    const [filterKind, setFilterKind] = useState("ALL");

    const [calcDeviceId, setCalcDeviceId] = useState(devicesDB[0].id);
    const [calcMonoPages, setCalcMonoPages] = useState(2500);
    const [calcColorPages, setCalcColorPages] = useState(500);

    useEffect(() => {
        const t1 = setTimeout(() => setIntroStage("sliding"), 2000);
        const t2 = setTimeout(() => setIntroStage("done"), 2800);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        };
    }, []);

    useEffect(() => {
        if (introStage !== "done") return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("active");
                    }
                });
            },
            { threshold: 0.1 },
        );

        const elements = document.querySelectorAll(".reveal");
        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, [introStage]);

    useEffect(() => {
        if (
            isContactOpen ||
            selectedDevice ||
            isMobileMenuOpen ||
            legalModal ||
            introStage !== "done"
        ) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [
        isContactOpen,
        selectedDevice,
        isMobileMenuOpen,
        legalModal,
        introStage,
    ]);

    useEffect(() => {
        document.documentElement.lang = "pl";
        document.title =
            "PixelPrintShop | Optymalizacja Druku i Wynajem Drukarek B2B (MPS)";

        const metaTags = [
            {
                name: "description",
                content:
                    "PixelPrintShop: Zarządzanie flotą drukującą dla biznesu (MPS). Wynajem kopiarek Konica Minolta, Canon, Kyocera. Rozliczenie za stronę, pełen serwis i audyt.",
            },
            {
                name: "keywords",
                content:
                    "wynajem drukarek, dzierżawa kopiarek, MPS, managed print services, optymalizacja druku, Konica Minolta, Kyocera, Canon, serwis drukarek B2B",
            },
            {
                name: "theme-color",
                content: isDarkMode ? "#000000" : "#fafafa",
            },
            {
                property: "og:title",
                content: "PixelPrintShop | Zarządzanie Drukiem B2B",
            },
            {
                property: "og:description",
                content:
                    "Przejmij kontrolę nad kosztami druku w firmie. Płać tylko za efekt.",
            },
            { property: "og:type", content: "website" },
            { property: "og:url", content: "https://pixelprintshop.pl" },
            {
                name: "robots",
                content:
                    "index, follow, max-image-preview:large, max-snippet:-1",
            },
        ];

        metaTags.forEach((tagInfo) => {
            const selector = tagInfo.name
                ? `meta[name="${tagInfo.name}"]`
                : `meta[property="${tagInfo.property}"]`;
            let meta = document.querySelector(selector);
            if (!meta) {
                meta = document.createElement("meta");
                if (tagInfo.name) meta.name = tagInfo.name;
                if (tagInfo.property)
                    meta.setAttribute("property", tagInfo.property);
                document.head.appendChild(meta);
            }
            meta.content = tagInfo.content;
        });

        let favicon = document.querySelector('link[rel="icon"]');
        if (!favicon) {
            favicon = document.createElement("link");
            favicon.rel = "icon";
            document.head.appendChild(favicon);
        }
        favicon.href =
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath d='M10 90 L35 10 L85 10 L60 90 Z' fill='%232563eb' /%3E%3Cpath d='M10 90 L35 10 L55 10 L30 90 Z' fill='%23f97316' /%3E%3Cpath d='M45 40 L100 40 L85 65 L30 65 Z' fill='%2338bdf8' /%3E%3Cpath d='M60 10 L85 10 L75 40 L50 40 Z' fill='%23ffffff' fill-opacity='0.2' /%3E%3C/svg%3E";

        let structuredData = document.querySelector(
            'script[type="application/ld+json"]',
        );
        if (!structuredData) {
            structuredData = document.createElement("script");
            structuredData.type = "application/ld+json";
            document.head.appendChild(structuredData);
        }

        const jsonLdData = {
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type": "LocalBusiness",
                    "@id": "https://pixelprintshop.pl/#organization",
                    name: "PixelPrintShop",
                    url: "https://pixelprintshop.pl",
                    email: "kontakt@pixelprintshop.pl",
                    description:
                        "Profesjonalne zarządzanie flotą drukującą dla biznesu (MPS). Wynajem i serwis kopiarek oraz drukarek w modelu abonamentowym.",
                    areaServed: "PL",
                },
                {
                    "@type": "FAQPage",
                    mainEntity: faqs.map((faq) => ({
                        "@type": "Question",
                        name: faq.q,
                        acceptedAnswer: { "@type": "Answer", text: faq.a },
                    })),
                },
            ],
        };
        structuredData.textContent = JSON.stringify(jsonLdData);
    }, [isDarkMode]);

    useEffect(() => {
        if (!document.querySelector('link[href*="fonts.googleapis.com"]')) {
            const preconnect1 = document.createElement("link");
            preconnect1.rel = "preconnect";
            preconnect1.href = "https://fonts.googleapis.com";

            const preconnect2 = document.createElement("link");
            preconnect2.rel = "preconnect";
            preconnect2.href = "https://fonts.gstatic.com";
            preconnect2.crossOrigin = "anonymous";

            const stylesheet = document.createElement("link");
            stylesheet.rel = "stylesheet";
            stylesheet.href =
                "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;700;900&family=Space+Grotesk:wght@300;400;500;700;900&display=swap";

            document.head.append(preconnect1, preconnect2, stylesheet);
        }

        const style = document.createElement("style");
        style.innerHTML = `
            :root {
                --font-body: 'Outfit', sans-serif;
                --font-heading: 'Space Grotesk', sans-serif;
            }
            body { font-family: var(--font-body); }
            h1, h2, h3, h4, h5, h6, .font-heading, .font-black { font-family: var(--font-heading); }
            
            @keyframes laserScan {
                0% { top: 0%; opacity: 0; }
                10% { opacity: 1; }
                90% { opacity: 1; }
                100% { top: 100%; opacity: 0; }
            }
            @keyframes marquee {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
            }
            @keyframes blobBounce {
                0% { transform: translate(0px, 0px) scale(1); }
                33% { transform: translate(30px, -50px) scale(1.1); }
                66% { transform: translate(-20px, 20px) scale(0.9); }
                100% { transform: translate(0px, 0px) scale(1); }
            }
            
            .animate-laser { animation: laserScan 3s cubic-bezier(0.4, 0, 0.2, 1) infinite; }
            .animate-marquee { animation: marquee 25s linear infinite; }
            .text-outline { -webkit-text-stroke: 2px var(--stroke-color); color: transparent; }
            .animate-blob { animation: blobBounce 15s infinite ease-in-out alternate; }
            .animation-delay-2000 { animation-delay: 2s; }

            input[type=range].brutalist-slider { -webkit-appearance: none; width: 100%; background: transparent; }
            input[type=range].brutalist-slider::-webkit-slider-thumb { -webkit-appearance: none; height: 24px; width: 12px; background: #f97316; cursor: pointer; margin-top: -10px; border-radius: 0; }
            input[type=range].brutalist-slider::-webkit-slider-runnable-track { width: 100%; height: 4px; cursor: pointer; background: var(--track-color); }
            
            .brutalist-scrollbar::-webkit-scrollbar { width: 8px; }
            .brutalist-scrollbar::-webkit-scrollbar-track { background: var(--track-color); border-left: 1px solid var(--stroke-color); }
            .brutalist-scrollbar::-webkit-scrollbar-thumb { background: #f97316; }
            .brutalist-scrollbar::-webkit-scrollbar-thumb:hover { background: #ea580c; }

            ::-webkit-scrollbar { width: 10px; }
            ::-webkit-scrollbar-track { background: var(--bg-body); border-left: 1px solid var(--stroke-color); }
            ::-webkit-scrollbar-thumb { background: #f97316; }
            ::-webkit-scrollbar-thumb:hover { background: #ea580c; }

            .reveal { opacity: 0; transform: translateY(40px); transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1); }
            .reveal.active { opacity: 1; transform: translateY(0); }
            .delay-100 { transition-delay: 100ms; }
            .delay-200 { transition-delay: 200ms; }
            .delay-300 { transition-delay: 300ms; }
            
            @keyframes fillBar { 0% { width: 0%; } 100% { width: 100%; } }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    const t = isDarkMode
        ? {
              bgBase: "bg-black",
              bgNav: "bg-black/80",
              bgCard: "bg-zinc-900",
              bgSection: "bg-zinc-950",
              textMain: "text-white",
              hoverTextMain: "hover:text-white",
              textSecondary: "text-zinc-400",
              border: "border-zinc-800",
              brandText: "text-blue-500",
              accentText: "text-orange-500",
              inputBg: "bg-black",
              divider: "bg-zinc-800",
              strokeColor: "rgba(255,255,255,0.20)",
              trackColor: "#27272a",
          }
        : {
              bgBase: "bg-zinc-50",
              bgNav: "bg-zinc-50/80",
              bgCard: "bg-white",
              bgSection: "bg-zinc-100",
              textMain: "text-black",
              hoverTextMain: "hover:text-black",
              textSecondary: "text-zinc-500",
              border: "border-zinc-300",
              brandText: "text-blue-600",
              accentText: "text-orange-500",
              inputBg: "bg-white",
              divider: "bg-zinc-300",
              strokeColor: "rgba(0,0,0,0.30)",
              trackColor: "#d4d4d8",
          };

    const scrollToSection = (e, id) => {
        e.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
            setIsMobileMenuOpen(false);
        }
    };

    const openContactWithContext = (contextType, data) => {
        setContactContext({ type: contextType, ...data });
        setFormStatus("idle");
        setIsContactOpen(true);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        setFormStatus("submitting");

        const payload = {
            access_key: "013d2394-80f3-4cb9-994c-5e018b064620",
            subject: "Nowe zapytanie B2B - PixelPrintShop",
            from_name: formData.get("contact_name"),
            email: formData.get("contact_email"),
            Telefon: formData.get("contact_phone") || "Nie podano",
            Firma_NIP: formData.get("contact_company") || "Nie podano",
            Miejscowosc: formData.get("contact_location") || "Nie podano",
            Wiadomosc: formData.get("contact_message") || "Brak",
        };

        if (!contactContext || contactContext.type !== "calculator") {
            payload.Wolumen_Mono = formData.get("contact_mono");
            payload.Wolumen_Kolor = formData.get("contact_color");
        }

        if (contactContext) {
            if (contactContext.type === "calculator") {
                payload.Zrodlo_Zapytania = "KALKULATOR KOSZTÓW";
                payload.Urzadzenie_Bazowe = `${contactContext.device.vendor} ${contactContext.device.model}`;
                payload.Zadeklarowany_Wolumen_Mono = `${contactContext.monoPages} stron`;
                payload.Zadeklarowany_Wolumen_Kolor = `${contactContext.colorPages} stron`;
                payload.Estymacja_Miesieczna = `${contactContext.totalCost.toFixed(2)} PLN netto`;
            } else if (contactContext.type === "device") {
                payload.Zrodlo_Zapytania = "KATALOG FLOTY (Konkretny model)";
                payload.Urzadzenie_Bazowe = `${contactContext.device.vendor} ${contactContext.device.model}`;
                payload.Cena_Abonamentu_Od = `${contactContext.device.lease} PLN netto`;
            }
        }

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (result.success) {
                setFormStatus("success");
                setTimeout(() => {
                    setIsContactOpen(false);
                    setFormStatus("idle");
                }, 4000);
            } else {
                setFormStatus("error");
            }
        } catch (error) {
            setFormStatus("error");
        }
    };

    const filteredDevices = devicesDB.filter((device) => {
        if (filterFormat !== "ALL" && device.format !== filterFormat)
            return false;
        if (filterType !== "ALL" && device.type !== filterType) return false;
        if (filterKind !== "ALL" && device.kind.toUpperCase() !== filterKind)
            return false;
        return true;
    });

    const calcDevice =
        devicesDB.find((d) => d.id === parseInt(calcDeviceId)) || devicesDB[0];
    const calcCostMono = (calcMonoPages * calcDevice.clickMono) / 100;
    const calcCostColor =
        calcDevice.type === "KOLOR"
            ? (calcColorPages * calcDevice.clickColor) / 100
            : 0;
    const calcTotalCost = calcDevice.lease + calcCostMono + calcCostColor;

    return (
        <div
            className={`min-h-screen ${t.bgBase} font-sans transition-colors duration-300 overflow-x-hidden`}
            style={{
                "--stroke-color": t.strokeColor,
                "--track-color": t.trackColor,
                "--bg-body": isDarkMode ? "#000000" : "#fafafa",
            }}
        >
            {introStage !== "done" && (
                <div
                    aria-hidden="true"
                    className={`fixed inset-0 z-[9999] bg-black flex flex-col items-center justify-center transition-transform duration-700 ease-[cubic-bezier(0.85,0,0.15,1)] ${introStage === "sliding" ? "-translate-y-full" : "translate-y-0"}`}
                >
                    <BrandLogo className="w-24 h-24 mb-8 animate-pulse" />
                    <div className="text-orange-500 font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase mb-6 animate-pulse">
                        Inicjalizacja Systemu MPS...
                    </div>
                    <div className="w-64 h-1 bg-zinc-900 overflow-hidden relative">
                        <div className="absolute top-0 left-0 h-full bg-blue-600 animate-[fillBar_2s_ease-out_forwards]"></div>
                    </div>
                </div>
            )}

            {!cookieConsent && (
                <div
                    role="dialog"
                    aria-label="Zgoda na pliki cookies"
                    className={`fixed bottom-0 left-0 w-full z-[90] ${t.bgCard} border-t ${t.border} p-4 md:p-6 flex flex-col sm:flex-row items-center justify-between shadow-[0_-10px_40px_rgba(0,0,0,0.1)]`}
                >
                    <div className="flex items-start sm:items-center text-sm mb-4 sm:mb-0 max-w-4xl">
                        <Cookie
                            className="w-5 h-5 mr-3 text-orange-500 flex-shrink-0 mt-0.5 sm:mt-0"
                            aria-hidden="true"
                        />
                        <p className={t.textSecondary}>
                            Serwis wykorzystuje pliki cookies do prawidłowego
                            działania, personalizacji oraz celów analitycznych.
                            Dalsze korzystanie z serwisu oznacza akceptację{" "}
                            <button
                                onClick={() => setLegalModal("policy")}
                                className={`underline ${t.textMain} hover:text-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500`}
                            >
                                Polityki Prywatności
                            </button>
                            .
                        </p>
                    </div>
                    <button
                        onClick={handleAcceptCookies}
                        className={`whitespace-nowrap bg-orange-500 text-white px-8 py-3 text-xs font-bold uppercase tracking-widest hover:bg-orange-400 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                    >
                        Rozumiem
                    </button>
                </div>
            )}

            <header
                className={`fixed w-full ${t.bgNav} backdrop-blur-xl z-50 border-b ${t.border} transition-colors duration-300`}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-24 items-center">
                        <a
                            href="#home"
                            onClick={(e) => scrollToSection(e, "home")}
                            aria-label="Strona Główna PixelPrintShop"
                            className="flex-shrink-0 flex items-center group decoration-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <div
                                className={`w-12 h-12 flex items-center justify-center mr-4 bg-transparent`}
                            >
                                <BrandLogo
                                    className={`w-10 h-10 group-hover:scale-110 transition-transform`}
                                />
                            </div>
                            <div className="flex flex-col">
                                <span
                                    className={`font-heading font-black text-2xl tracking-tighter uppercase ${t.textMain} leading-none`}
                                >
                                    PIXEL
                                    <span className="text-blue-600">PRINT</span>
                                    SHOP
                                </span>
                            </div>
                        </a>

                        <nav
                            className="hidden lg:flex items-center space-x-2"
                            aria-label="Nawigacja główna"
                        >
                            <a
                                href="#oferta"
                                onClick={(e) => scrollToSection(e, "oferta")}
                                className={`px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary} ${t.hoverTextMain} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                Oferta
                            </a>
                            <a
                                href="#cennik"
                                onClick={(e) => scrollToSection(e, "cennik")}
                                className={`px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary} ${t.hoverTextMain} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                Cennik
                            </a>
                            <a
                                href="#kalkulator"
                                onClick={(e) =>
                                    scrollToSection(e, "kalkulator")
                                }
                                className={`px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary} ${t.hoverTextMain} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                Kalkulator
                            </a>
                            <a
                                href="#katalog"
                                onClick={(e) => scrollToSection(e, "katalog")}
                                className={`px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold ${t.accentText} hover:text-orange-400 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500`}
                            >
                                Katalog
                            </a>
                            <a
                                href="#oprogramowanie"
                                onClick={(e) =>
                                    scrollToSection(e, "oprogramowanie")
                                }
                                className={`px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary} ${t.hoverTextMain} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                Software
                            </a>
                            <a
                                href="#faq"
                                onClick={(e) => scrollToSection(e, "faq")}
                                className={`px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary} ${t.hoverTextMain} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                FAQ
                            </a>

                            <div className={`h-8 w-px ${t.divider} mx-2`}></div>

                            <button
                                aria-label="Przełącz motyw"
                                onClick={() => setIsDarkMode(!isDarkMode)}
                                className={`p-3 ${t.textSecondary} ${t.hoverTextMain} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                {isDarkMode ? (
                                    <Sun
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    <Moon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                    />
                                )}
                            </button>

                            <button
                                onClick={() => {
                                    setContactContext(null);
                                    setFormStatus("idle");
                                    setIsContactOpen(true);
                                }}
                                className={`ml-4 bg-blue-600 text-white px-8 py-3 text-xs uppercase tracking-[0.2em] font-bold hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] hover:shadow-[0_0_30px_rgba(37,99,235,0.5)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                            >
                                Rozpocznij
                            </button>
                        </nav>

                        <div className="lg:hidden flex items-center space-x-2">
                            <button
                                aria-label="Przełącz motyw"
                                onClick={() => setIsDarkMode(!isDarkMode)}
                                className={`p-2 ${t.textSecondary} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                {isDarkMode ? (
                                    <Sun
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    <Moon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                    />
                                )}
                            </button>
                            <button
                                aria-label="Menu mobilne"
                                aria-expanded={isMobileMenuOpen}
                                onClick={() =>
                                    setIsMobileMenuOpen(!isMobileMenuOpen)
                                }
                                className={`${t.textSecondary} ${t.hoverTextMain} p-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            >
                                {isMobileMenuOpen ? (
                                    <X className="h-8 w-8" aria-hidden="true" />
                                ) : (
                                    <Menu
                                        className="h-8 w-8"
                                        aria-hidden="true"
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {isMobileMenuOpen && (
                    <nav
                        aria-label="Nawigacja mobilna"
                        className={`lg:hidden ${t.bgBase} border-t ${t.border} px-4 pt-4 pb-8 shadow-2xl absolute w-full`}
                    >
                        <div className="flex flex-col space-y-2">
                            <a
                                href="#oferta"
                                onClick={(e) => scrollToSection(e, "oferta")}
                                className={`block w-full text-left px-4 py-5 text-sm uppercase tracking-widest font-bold ${t.textSecondary} border-b ${t.border}`}
                            >
                                Oferta
                            </a>
                            <a
                                href="#cennik"
                                onClick={(e) => scrollToSection(e, "cennik")}
                                className={`block w-full text-left px-4 py-5 text-sm uppercase tracking-widest font-bold ${t.textSecondary} border-b ${t.border}`}
                            >
                                Cennik
                            </a>
                            <a
                                href="#kalkulator"
                                onClick={(e) =>
                                    scrollToSection(e, "kalkulator")
                                }
                                className={`block w-full text-left px-4 py-5 text-sm uppercase tracking-widest font-bold ${t.textSecondary} border-b ${t.border}`}
                            >
                                Kalkulator
                            </a>
                            <a
                                href="#katalog"
                                onClick={(e) => scrollToSection(e, "katalog")}
                                className={`block w-full text-left px-4 py-5 text-sm uppercase tracking-widest font-bold ${t.accentText} border-b ${t.border}`}
                            >
                                Katalog Floty
                            </a>
                            <a
                                href="#oprogramowanie"
                                onClick={(e) =>
                                    scrollToSection(e, "oprogramowanie")
                                }
                                className={`block w-full text-left px-4 py-5 text-sm uppercase tracking-widest font-bold ${t.textSecondary} border-b ${t.border}`}
                            >
                                Software
                            </a>
                            <a
                                href="#faq"
                                onClick={(e) => scrollToSection(e, "faq")}
                                className={`block w-full text-left px-4 py-5 text-sm uppercase tracking-widest font-bold ${t.textSecondary} border-b ${t.border}`}
                            >
                                FAQ
                            </a>
                            <button
                                onClick={() => {
                                    setContactContext(null);
                                    setFormStatus("idle");
                                    setIsContactOpen(true);
                                    setIsMobileMenuOpen(false);
                                }}
                                className={`w-full mt-6 bg-blue-600 text-white px-4 py-5 text-sm uppercase tracking-widest font-bold text-center`}
                            >
                                Skontaktuj się
                            </button>
                        </div>
                    </nav>
                )}
            </header>

            <main>
                <section
                    id="home"
                    aria-labelledby="hero-title"
                    className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex items-center min-h-[90vh]"
                >
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full flex justify-center pointer-events-none select-none overflow-hidden -z-10 reveal">
                        <span
                            aria-hidden="true"
                            className="font-heading text-[15vw] font-black whitespace-nowrap text-outline opacity-50"
                        >
                            MANAGED PRINT
                        </span>
                    </div>

                    <div className="grid lg:grid-cols-12 gap-12 items-center w-full relative z-10">
                        <div className="lg:col-span-7 reveal">
                            <div
                                className={`inline-flex items-center space-x-3 text-xs font-bold uppercase tracking-[0.3em] ${t.brandText} mb-8`}
                            >
                                <span
                                    className="w-12 h-[2px] bg-blue-600"
                                    aria-hidden="true"
                                ></span>
                                <span>Hardware B2B</span>
                            </div>

                            <h1
                                id="hero-title"
                                className={`font-heading text-6xl sm:text-7xl lg:text-[5.5rem] font-black tracking-tighter ${t.textMain} mb-8 leading-[0.9] uppercase`}
                            >
                                Drukuj. <br /> Płać za <br />{" "}
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-400">
                                    efekt.
                                </span>
                            </h1>

                            <p
                                className={`text-xl ${t.textSecondary} mb-12 max-w-lg leading-relaxed font-light border-l-2 ${t.border} pl-6`}
                            >
                                Wynajem zaawansowanych urządzeń laserowych z
                                rozliczeniem za stronę. Przejmij kontrolę nad
                                kosztami. Zero kompromisów.
                            </p>

                            <div className="flex flex-col sm:flex-row gap-6">
                                <button
                                    onClick={() => {
                                        setContactContext(null);
                                        setFormStatus("idle");
                                        setIsContactOpen(true);
                                    }}
                                    className={`bg-blue-600 hover:bg-blue-500 text-white px-10 py-5 text-sm uppercase tracking-widest font-bold transition-all flex items-center justify-center group shadow-[0_0_20px_rgba(37,99,235,0.3)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                                >
                                    Wyceń projekt{" "}
                                    <ArrowRight
                                        className="ml-4 w-5 h-5 group-hover:translate-x-2 transition-transform"
                                        aria-hidden="true"
                                    />
                                </button>
                                <a
                                    href="#kalkulator"
                                    onClick={(e) =>
                                        scrollToSection(e, "kalkulator")
                                    }
                                    className={`${t.textMain} border ${t.border} hover:border-orange-500 px-10 py-5 text-sm uppercase tracking-widest font-bold transition-all flex items-center justify-center bg-transparent group focus:outline-none focus:ring-2 focus:ring-orange-500`}
                                >
                                    Kalkulator
                                </a>
                            </div>
                        </div>

                        <div
                            className="lg:col-span-5 relative hidden lg:block reveal delay-200"
                            aria-hidden="true"
                        >
                            <div
                                className={`relative w-full aspect-[4/5] border ${t.border} ${isDarkMode ? "bg-zinc-900/50" : "bg-white/80"} backdrop-blur-sm p-8 flex flex-col justify-between overflow-hidden shadow-2xl`}
                            >
                                <div className="absolute left-0 w-full h-1 bg-orange-500 shadow-[0_0_15px_rgba(249,115,22,1),0_0_30px_rgba(249,115,22,0.8)] animate-laser z-20"></div>
                                <div className="absolute inset-0 bg-[linear-gradient(rgba(120,120,120,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(120,120,120,0.1)_1px,transparent_1px)] bg-[size:20px_20px] pointer-events-none"></div>

                                <div className="flex justify-between items-start relative z-10">
                                    <Cpu
                                        className={`w-12 h-12 text-blue-500`}
                                        strokeWidth={1}
                                    />
                                    <div
                                        className={`text-right ${t.textSecondary} text-[10px] font-mono uppercase tracking-[0.2em]`}
                                    >
                                        SYS.REQ // 2024 <br />{" "}
                                        <span className="text-orange-500 animate-pulse">
                                            ONLINE
                                        </span>
                                    </div>
                                </div>

                                <div className="space-y-8 relative z-10">
                                    <div className="relative group">
                                        <p
                                            className={`text-[10px] ${t.textSecondary} uppercase tracking-widest mb-1`}
                                        >
                                            Technologia
                                        </p>
                                        <p
                                            className={`font-heading text-2xl font-black ${t.textMain} uppercase tracking-tight`}
                                        >
                                            Laser Mono/Color
                                        </p>
                                    </div>
                                    <div className="relative">
                                        <p
                                            className={`text-[10px] ${t.textSecondary} uppercase tracking-widest mb-1`}
                                        >
                                            Model Biznesowy
                                        </p>
                                        <p
                                            className={`font-heading text-2xl font-black ${t.textMain} uppercase tracking-tight`}
                                        >
                                            Per Page
                                        </p>
                                    </div>
                                    <div className="relative">
                                        <p
                                            className={`text-[10px] ${t.textSecondary} uppercase tracking-widest mb-1`}
                                        >
                                            Wsparcie
                                        </p>
                                        <p
                                            className={`font-heading text-2xl font-black text-blue-500 uppercase tracking-tight`}
                                        >
                                            Full Service
                                        </p>
                                    </div>
                                </div>

                                <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-orange-500"></div>
                                <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-orange-500"></div>
                                <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-orange-500"></div>
                                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-orange-500"></div>
                            </div>
                        </div>
                    </div>
                </section>

                <div
                    className={`border-y ${t.border} ${t.bgSection} overflow-hidden flex whitespace-nowrap py-10 relative`}
                    aria-hidden="true"
                >
                    <div
                        className={`absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r ${isDarkMode ? "from-black" : "from-zinc-50"} to-transparent z-10`}
                    ></div>
                    <div
                        className={`absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l ${isDarkMode ? "from-black" : "from-zinc-50"} to-transparent z-10`}
                    ></div>
                    <div className="flex animate-marquee items-center font-heading">
                        {[1, 2].map((set) => (
                            <div
                                key={set}
                                className="flex items-center space-x-16 px-8"
                            >
                                <span
                                    className={`text-4xl sm:text-5xl font-black tracking-tighter ${t.textMain} uppercase`}
                                >
                                    KONICA MINOLTA
                                </span>
                                <span
                                    className={`text-4xl font-light ${t.accentText}`}
                                >
                                    //
                                </span>
                                <span
                                    className={`text-4xl sm:text-5xl font-black tracking-widest text-outline uppercase`}
                                >
                                    KYOCERA
                                </span>
                                <span
                                    className={`text-4xl font-light ${t.accentText}`}
                                >
                                    //
                                </span>
                                <span
                                    className={`text-4xl sm:text-5xl font-black tracking-tighter ${t.textMain} uppercase`}
                                >
                                    CANON
                                </span>
                                <span
                                    className={`text-4xl font-light ${t.accentText}`}
                                >
                                    //
                                </span>
                                <span
                                    className={`text-4xl sm:text-5xl font-black tracking-widest text-outline uppercase`}
                                >
                                    PREMIUM MPS
                                </span>
                                <span
                                    className={`text-4xl font-light ${t.accentText} ml-16`}
                                >
                                    //
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                <div
                    className={`w-full h-px bg-gradient-to-r from-transparent via-orange-500/50 to-transparent relative z-10`}
                ></div>

                <section
                    id="oferta"
                    aria-labelledby="oferta-title"
                    className={`py-32 ${t.bgBase} relative`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-20 reveal">
                            <h2
                                id="oferta-title"
                                className={`font-heading text-5xl md:text-6xl font-black tracking-tighter ${t.textMain} uppercase mb-6`}
                            >
                                Rdzeń
                                <br />
                                <span className="text-blue-600">Oferty.</span>
                            </h2>
                            <p
                                className={`text-xl ${t.textSecondary} font-light max-w-2xl`}
                            >
                                Transformacja kosztów stałych w zmienne.
                                Dostarczamy potężne narzędzia do pracy bez
                                martwienia się o eksploatację.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-3 gap-6">
                            {[
                                {
                                    icon: (
                                        <Layers
                                            className="w-10 h-10"
                                            strokeWidth={1.5}
                                            aria-hidden="true"
                                        />
                                    ),
                                    title: "Wynajem Maszyn",
                                    desc: "Topowe urządzenia dopasowane do realnego obciążenia biura. Zero zamrożonego kapitału.",
                                },
                                {
                                    icon: (
                                        <Zap
                                            className="w-10 h-10"
                                            strokeWidth={1.5}
                                            aria-hidden="true"
                                        />
                                    ),
                                    title: "Rozliczenie Per Strona",
                                    desc: "Płacisz grosze za to, co wyjdzie z tacy. Przejrzyste zasady bez ukrytych opłat za tonery.",
                                },
                                {
                                    icon: (
                                        <Settings
                                            className="w-10 h-10"
                                            strokeWidth={1.5}
                                            aria-hidden="true"
                                        />
                                    ),
                                    title: "Serwis Totalny",
                                    desc: "Części, przeglądy, naprawy - po naszej stronie. Skup się na biznesie, my dbamy o sprzęt.",
                                },
                            ].map((feature, idx) => (
                                <article
                                    key={idx}
                                    className={`${t.bgCard} p-12 border ${t.border} group hover:border-blue-500 transition-colors relative overflow-hidden reveal`}
                                    style={{
                                        transitionDelay: `${idx * 100}ms`,
                                    }}
                                >
                                    <div
                                        className={`mb-10 text-zinc-700 group-hover:text-blue-500 transition-colors`}
                                    >
                                        {feature.icon}
                                    </div>
                                    <h3
                                        className={`font-heading text-2xl font-black ${t.textMain} mb-4 uppercase tracking-wide`}
                                    >
                                        {feature.title}
                                    </h3>
                                    <p
                                        className={`${t.textSecondary} leading-relaxed text-sm`}
                                    >
                                        {feature.desc}
                                    </p>
                                    <div className="absolute bottom-0 left-0 w-0 h-1 bg-blue-600 group-hover:w-full transition-all duration-500"></div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section
                    id="korzysci"
                    aria-labelledby="korzysci-title"
                    className={`py-32 bg-blue-600 relative overflow-hidden border-y border-blue-400/30`}
                >
                    <div
                        className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"
                        aria-hidden="true"
                    ></div>
                    <div
                        className="absolute right-0 top-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/20 rounded-full blur-[120px] pointer-events-none"
                        aria-hidden="true"
                    ></div>

                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-20 reveal">
                            <h2
                                id="korzysci-title"
                                className={`font-heading text-5xl md:text-6xl font-black tracking-tighter text-white uppercase mb-6`}
                            >
                                Dlaczego{" "}
                                <span className="text-orange-400">MPS?</span>
                            </h2>
                            <p
                                className={`text-xl text-blue-100 font-light max-w-2xl`}
                            >
                                Managed Print Services to nie tylko wynajem
                                drukarki. To strategiczna decyzja, która
                                transformuje sposób, w jaki firma zarządza
                                dokumentami i kosztami.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {[
                                {
                                    title: "Redukcja Kosztów do 30%",
                                    desc: "Eliminujemy ukryte koszty. Płacisz ułamek grosza wyłącznie za faktycznie wygenerowaną stronę. Zero zapasów tonerów w szafie.",
                                    num: "01",
                                },
                                {
                                    title: "Odciążenie Działu IT",
                                    desc: "Twoi informatycy mają ważniejsze zadania niż odblokowywanie papieru. Bierzemy na siebie 100% problemów ze sprzętem.",
                                    num: "02",
                                },
                                {
                                    title: "Ciągłość Biznesu (SLA)",
                                    desc: "Umowa gwarantuje błyskawiczną reakcję serwisu. W przypadku poważnej awarii natychmiast podstawiamy sprzęt zastępczy.",
                                    num: "03",
                                },
                                {
                                    title: "Cyberbezpieczeństwo",
                                    desc: "Autoryzacja RFID, szyfrowane dyski SSD i nadpisywanie danych. Twoje poufne dokumenty nigdy nie wpadną w niepowołane ręce.",
                                    num: "04",
                                },
                            ].map((benefit, idx) => (
                                <article
                                    key={idx}
                                    className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 hover:bg-white/20 hover:border-orange-400 transition-all duration-300 group relative reveal"
                                    style={{
                                        transitionDelay: `${idx * 100}ms`,
                                    }}
                                >
                                    <div
                                        className="font-heading text-5xl font-black text-white/10 absolute top-4 right-4 group-hover:text-orange-400/20 transition-colors"
                                        aria-hidden="true"
                                    >
                                        {benefit.num}
                                    </div>
                                    <div className="w-12 h-12 bg-orange-500 flex items-center justify-center mb-8">
                                        <Check
                                            className="text-white w-6 h-6"
                                            strokeWidth={3}
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <h3 className="font-heading text-lg lg:text-xl font-black text-white uppercase tracking-wide mb-4 break-words">
                                        {benefit.title}
                                    </h3>
                                    <p className="text-blue-100 text-sm leading-relaxed">
                                        {benefit.desc}
                                    </p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section
                    id="cennik"
                    aria-labelledby="cennik-title"
                    className={`py-32 ${t.bgSection} relative`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-20 text-center reveal">
                            <h2
                                id="cennik-title"
                                className={`font-heading text-5xl md:text-6xl font-black tracking-tighter ${t.textMain} uppercase mb-6`}
                            >
                                Cennik{" "}
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-400">
                                    Podstawowy.
                                </span>
                            </h2>
                            <p
                                className={`text-xl ${t.textSecondary} font-light max-w-2xl mx-auto`}
                            >
                                Najniższe progi z naszego katalogu. Wycena
                                końcowa zależy od wybranego modelu.
                            </p>
                        </div>

                        <div className="grid lg:grid-cols-3 gap-8 items-center max-w-6xl mx-auto reveal delay-200">
                            <div
                                className={`border ${t.border} ${t.bgBase} p-10 flex flex-col`}
                            >
                                <div className="mb-10">
                                    <p
                                        className={`text-[10px] uppercase tracking-[0.2em] text-blue-600 font-bold mb-2`}
                                    >
                                        Wydruk
                                    </p>
                                    <h3
                                        className={`font-heading text-3xl font-black ${t.textMain} uppercase`}
                                    >
                                        Mono
                                    </h3>
                                </div>
                                <div
                                    className={`mb-10 border-b ${t.border} pb-10`}
                                >
                                    <div className="flex items-baseline gap-2">
                                        <span
                                            className={`${t.textSecondary} text-lg font-bold mr-1`}
                                        >
                                            OD
                                        </span>
                                        <span
                                            className={`font-heading text-6xl font-black ${t.textMain}`}
                                        >
                                            3
                                        </span>
                                        <span
                                            className={`text-xl font-bold ${t.textSecondary}`}
                                        >
                                            gr
                                        </span>
                                    </div>
                                    <span
                                        className={`text-xs uppercase tracking-widest ${t.textSecondary} mt-2 block`}
                                    >
                                        netto / strona
                                    </span>
                                </div>
                            </div>

                            <div
                                className={`relative p-10 flex flex-col transform lg:-translate-y-6 ${isDarkMode ? "bg-zinc-900" : "bg-white"}`}
                            >
                                <div
                                    className="absolute inset-0 bg-gradient-to-b from-blue-600 to-cyan-400 p-[2px] rounded-sm"
                                    aria-hidden="true"
                                >
                                    <div
                                        className={`w-full h-full ${isDarkMode ? "bg-zinc-950" : "bg-zinc-50"}`}
                                    ></div>
                                </div>
                                <div className="relative z-10 flex flex-col h-full">
                                    <div className="absolute top-0 right-0 bg-blue-600 text-white text-[10px] font-black uppercase tracking-widest py-2 px-4 shadow-[0_0_15px_rgba(37,99,235,0.5)]">
                                        Start
                                    </div>
                                    <div className="mb-10 mt-4">
                                        <p
                                            className={`text-[10px] uppercase tracking-[0.2em] text-cyan-500 font-bold mb-2`}
                                        >
                                            Dzierżawa
                                        </p>
                                        <h3
                                            className={`font-heading text-3xl font-black ${t.textMain} uppercase`}
                                        >
                                            Abonament
                                        </h3>
                                    </div>
                                    <div
                                        className={`mb-10 border-b ${isDarkMode ? "border-zinc-800" : "border-zinc-200"} pb-10`}
                                    >
                                        <div className="flex items-baseline gap-2">
                                            <span
                                                className={`${t.textSecondary} text-lg font-bold mr-1`}
                                            >
                                                OD
                                            </span>
                                            <span
                                                className={`font-heading text-7xl font-black ${t.textMain}`}
                                            >
                                                19
                                            </span>
                                            <span
                                                className={`text-xl font-bold ${t.textSecondary}`}
                                            >
                                                zł
                                            </span>
                                        </div>
                                        <span
                                            className={`text-xs uppercase tracking-widest ${t.textSecondary} mt-2 block`}
                                        >
                                            netto / mc
                                        </span>
                                    </div>
                                    <button
                                        onClick={() => {
                                            setContactContext(null);
                                            setFormStatus("idle");
                                            setIsContactOpen(true);
                                        }}
                                        className={`w-full py-5 bg-blue-600 text-white text-sm uppercase tracking-[0.2em] font-black hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.4)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                                    >
                                        Wyceń model
                                    </button>
                                </div>
                            </div>

                            <div
                                className={`border ${t.border} ${t.bgBase} p-10 flex flex-col`}
                            >
                                <div className="mb-10">
                                    <p
                                        className={`text-[10px] uppercase tracking-[0.2em] text-blue-600 font-bold mb-2`}
                                    >
                                        Wydruk
                                    </p>
                                    <h3
                                        className={`font-heading text-3xl font-black ${t.textMain} uppercase`}
                                    >
                                        Kolor
                                    </h3>
                                </div>
                                <div
                                    className={`mb-10 border-b ${t.border} pb-10`}
                                >
                                    <div className="flex items-baseline gap-2">
                                        <span
                                            className={`${t.textSecondary} text-lg font-bold mr-1`}
                                        >
                                            OD
                                        </span>
                                        <span
                                            className={`font-heading text-6xl font-black ${t.textMain}`}
                                        >
                                            15
                                        </span>
                                        <span
                                            className={`text-xl font-bold ${t.textSecondary}`}
                                        >
                                            gr
                                        </span>
                                    </div>
                                    <span
                                        className={`text-xs uppercase tracking-widest ${t.textSecondary} mt-2 block`}
                                    >
                                        netto / strona
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div
                    className={`w-full h-px bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent relative z-10`}
                    aria-hidden="true"
                ></div>

                <section
                    id="kalkulator"
                    aria-labelledby="kalkulator-title"
                    className={`py-32 ${t.bgBase} relative overflow-hidden`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-16 text-center reveal">
                            <Calculator
                                className={`w-12 h-12 mx-auto mb-6 text-blue-500`}
                                strokeWidth={1.5}
                                aria-hidden="true"
                            />
                            <h2
                                id="kalkulator-title"
                                className={`font-heading text-5xl md:text-6xl font-black tracking-tighter ${t.textMain} uppercase mb-4`}
                            >
                                Kalkulator{" "}
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-400">
                                    Kosztów.
                                </span>
                            </h2>
                            <p
                                className={`text-xl ${t.textSecondary} font-light`}
                            >
                                Wybierz sprzęt, ustaw suwaki i sprawdź
                                natychmiast, jak optymalizujemy Twój budżet.
                            </p>
                        </div>

                        <div
                            className={`grid lg:grid-cols-12 gap-12 border ${t.border} ${t.bgSection} p-8 md:p-12 relative reveal delay-100`}
                        >
                            <div className="lg:col-span-7 flex flex-col justify-center space-y-10">
                                <div>
                                    <label
                                        htmlFor="base_device_select"
                                        className={`block text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary} mb-4`}
                                    >
                                        Wybierz Maszynę Bazową
                                    </label>
                                    <select
                                        id="base_device_select"
                                        className={`w-full px-5 py-4 border ${t.border} focus:border-orange-500 outline-none transition-colors ${t.inputBg} ${t.textMain} font-bold tracking-wide rounded-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-transparent`}
                                        value={calcDeviceId}
                                        onChange={(e) => {
                                            setCalcDeviceId(
                                                Number(e.target.value),
                                            );
                                            const newDevice = devicesDB.find(
                                                (d) =>
                                                    d.id ===
                                                    Number(e.target.value),
                                            );
                                            if (newDevice.type === "MONO")
                                                setCalcColorPages(0);
                                        }}
                                    >
                                        {devicesDB.map((d) => (
                                            <option key={d.id} value={d.id}>
                                                {d.vendor} {d.model} ({d.format}{" "}
                                                / {d.kind} / {d.type})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <div className="flex justify-between items-end mb-4">
                                        <label
                                            htmlFor="mono_pages_slider"
                                            className={`block text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary}`}
                                        >
                                            Wolumen Wydruków MONO
                                        </label>
                                        <span
                                            className={`font-heading text-xl font-black ${t.textMain}`}
                                        >
                                            {calcMonoPages}{" "}
                                            <span className="font-sans text-xs font-normal text-zinc-500 uppercase">
                                                stron
                                            </span>
                                        </span>
                                    </div>
                                    <input
                                        id="mono_pages_slider"
                                        type="range"
                                        min="0"
                                        max="20000"
                                        step="500"
                                        value={calcMonoPages}
                                        onChange={(e) =>
                                            setCalcMonoPages(
                                                Number(e.target.value),
                                            )
                                        }
                                        className="brutalist-slider"
                                        aria-label="Suwak ilości stron mono"
                                    />
                                </div>

                                <div
                                    className={`${calcDevice.type === "MONO" ? "opacity-30 pointer-events-none" : ""} transition-opacity duration-300`}
                                >
                                    <div className="flex justify-between items-end mb-4">
                                        <label
                                            htmlFor="color_pages_slider"
                                            className={`block text-[10px] uppercase tracking-[0.2em] font-bold ${t.textSecondary}`}
                                        >
                                            Wolumen Wydruków KOLOR
                                        </label>
                                        <span
                                            className={`font-heading text-xl font-black ${t.textMain}`}
                                        >
                                            {calcColorPages}{" "}
                                            <span className="font-sans text-xs font-normal text-zinc-500 uppercase">
                                                stron
                                            </span>
                                        </span>
                                    </div>
                                    <input
                                        id="color_pages_slider"
                                        type="range"
                                        min="0"
                                        max="10000"
                                        step="100"
                                        value={calcColorPages}
                                        onChange={(e) =>
                                            setCalcColorPages(
                                                Number(e.target.value),
                                            )
                                        }
                                        className="brutalist-slider"
                                        disabled={calcDevice.type === "MONO"}
                                        aria-label="Suwak ilości stron kolor"
                                    />
                                    {calcDevice.type === "MONO" && (
                                        <p className="text-xs text-orange-500 mt-2 font-bold uppercase tracking-widest">
                                            Wybrane urządzenie nie obsługuje
                                            druku w kolorze.
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div
                                className={`lg:col-span-5 border ${t.border} ${isDarkMode ? "bg-zinc-900/50" : "bg-white"} p-8 flex flex-col justify-center relative`}
                            >
                                <div
                                    className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-blue-500 m-4"
                                    aria-hidden="true"
                                ></div>
                                <div
                                    className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-blue-500 m-4"
                                    aria-hidden="true"
                                ></div>

                                <h3
                                    className={`text-[10px] uppercase tracking-[0.3em] font-bold ${t.textSecondary} mb-8 border-b ${t.border} pb-4`}
                                >
                                    Estymacja Miesięczna
                                </h3>

                                <div className="space-y-4 mb-10 flex-grow">
                                    <div className="flex justify-between items-center">
                                        <span
                                            className={`text-sm ${t.textSecondary}`}
                                        >
                                            Rata Dzierżawy
                                        </span>
                                        <span
                                            className={`text-sm font-bold ${t.textMain}`}
                                        >
                                            {calcDevice.lease.toFixed(2)} zł
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span
                                            className={`text-sm ${t.textSecondary}`}
                                        >
                                            Koszty Mono ({calcDevice.clickMono}{" "}
                                            gr/str)
                                        </span>
                                        <span
                                            className={`text-sm font-bold ${t.textMain}`}
                                        >
                                            {calcCostMono.toFixed(2)} zł
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span
                                            className={`text-sm ${t.textSecondary}`}
                                        >
                                            Koszty Kolor (
                                            {calcDevice.clickColor || 0} gr/str)
                                        </span>
                                        <span
                                            className={`text-sm font-bold ${t.textMain}`}
                                        >
                                            {calcCostColor.toFixed(2)} zł
                                        </span>
                                    </div>
                                </div>

                                <div
                                    className={`border-t border-blue-500/30 pt-8`}
                                >
                                    <p
                                        className={`text-[10px] uppercase tracking-[0.2em] font-bold text-blue-500 mb-2`}
                                    >
                                        Całkowity Koszt Netto
                                    </p>
                                    <div className="flex items-baseline gap-2">
                                        <span
                                            className={`font-heading text-5xl font-black ${t.textMain}`}
                                        >
                                            {calcTotalCost.toFixed(2)}
                                        </span>
                                        <span
                                            className={`text-xl font-bold ${t.textSecondary}`}
                                        >
                                            zł / mc
                                        </span>
                                    </div>
                                </div>

                                <button
                                    onClick={() =>
                                        openContactWithContext("calculator", {
                                            device: calcDevice,
                                            monoPages: calcMonoPages,
                                            colorPages: calcColorPages,
                                            totalCost: calcTotalCost,
                                        })
                                    }
                                    className={`w-full mt-8 py-5 bg-blue-600 text-white text-sm uppercase tracking-[0.2em] font-black hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                                >
                                    Zapytaj o ten wariant
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <div
                    className={`w-full h-px bg-gradient-to-r from-transparent via-orange-500/50 to-transparent relative z-10`}
                    aria-hidden="true"
                ></div>

                <section
                    id="katalog"
                    aria-labelledby="katalog-title"
                    className={`py-32 ${t.bgSection} relative`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-12 flex flex-col xl:flex-row xl:items-end justify-between border-b border-zinc-800 pb-8 reveal">
                            <div className="mb-8 xl:mb-0">
                                <h2
                                    id="katalog-title"
                                    className={`font-heading text-5xl md:text-6xl font-black tracking-tighter ${t.textMain} uppercase mb-4`}
                                >
                                    Katalog <br />
                                    <span className={t.accentText}>Floty.</span>
                                </h2>
                                <p
                                    className={`text-xl ${t.textSecondary} font-light`}
                                >
                                    Przeszukaj bazę flagowych urządzeń i sprawdź
                                    realne koszty.
                                </p>
                            </div>

                            <div
                                className="flex flex-col sm:flex-row gap-6"
                                aria-label="Filtry katalogu"
                            >
                                <div className="flex flex-col space-y-2">
                                    <span
                                        className={`text-[10px] uppercase tracking-widest font-bold ${t.textSecondary} flex items-center`}
                                    >
                                        <Filter
                                            className="w-3 h-3 mr-2"
                                            aria-hidden="true"
                                        />{" "}
                                        Format
                                    </span>
                                    <div className="flex space-x-2">
                                        {["ALL", "A3", "A4"].map((fmt) => (
                                            <button
                                                key={fmt}
                                                onClick={() =>
                                                    setFilterFormat(fmt)
                                                }
                                                className={`px-4 py-2 text-[10px] font-bold tracking-widest border ${filterFormat === fmt ? "border-orange-500 text-orange-500" : `${t.border} ${t.textSecondary} ${t.hoverTextMain}`} transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500`}
                                            >
                                                {fmt === "ALL"
                                                    ? "Wszystkie"
                                                    : fmt}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="flex flex-col space-y-2">
                                    <span
                                        className={`text-[10px] uppercase tracking-widest font-bold ${t.textSecondary} flex items-center`}
                                    >
                                        <Filter
                                            className="w-3 h-3 mr-2"
                                            aria-hidden="true"
                                        />{" "}
                                        Rodzaj Druku
                                    </span>
                                    <div className="flex space-x-2">
                                        {["ALL", "MONO", "KOLOR"].map((typ) => (
                                            <button
                                                key={typ}
                                                onClick={() =>
                                                    setFilterType(typ)
                                                }
                                                className={`px-4 py-2 text-[10px] font-bold tracking-widest border ${filterType === typ ? "border-blue-500 text-blue-500" : `${t.border} ${t.textSecondary} ${t.hoverTextMain}`} transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                            >
                                                {typ === "ALL"
                                                    ? "Wszystkie"
                                                    : typ}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="flex flex-col space-y-2">
                                    <span
                                        className={`text-[10px] uppercase tracking-widest font-bold ${t.textSecondary} flex items-center`}
                                    >
                                        <Filter
                                            className="w-3 h-3 mr-2"
                                            aria-hidden="true"
                                        />{" "}
                                        Funkcja
                                    </span>
                                    <div className="flex space-x-2">
                                        {["ALL", "MFP", "DRUKARKA"].map(
                                            (kind) => (
                                                <button
                                                    key={kind}
                                                    onClick={() =>
                                                        setFilterKind(kind)
                                                    }
                                                    className={`px-4 py-2 text-[10px] font-bold tracking-widest border ${filterKind === kind ? "border-orange-500 text-orange-500" : `${t.border} ${t.textSecondary} ${t.hoverTextMain}`} transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500`}
                                                >
                                                    {kind === "ALL"
                                                        ? "Wszystkie"
                                                        : kind}
                                                </button>
                                            ),
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="max-h-[800px] overflow-y-auto brutalist-scrollbar pr-4 reveal delay-100"
                            tabIndex="0"
                            aria-label="Lista urządzeń"
                        >
                            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                                {filteredDevices.map((device) => (
                                    <article
                                        key={device.id}
                                        onClick={() =>
                                            setSelectedDevice(device)
                                        }
                                        tabIndex="0"
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter")
                                                setSelectedDevice(device);
                                        }}
                                        aria-label={`Zobacz szczegóły ${device.vendor} ${device.model}`}
                                        className={`border ${t.border} ${t.bgBase} p-6 relative group hover:border-orange-500 hover:shadow-[0_8px_30px_rgba(249,115,22,0.12)] transition-all duration-300 flex flex-col cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500`}
                                    >
                                        <div
                                            className={`absolute top-0 right-0 px-3 py-1 ${isDarkMode ? "bg-zinc-800 text-zinc-100" : "bg-zinc-200 text-zinc-800"} text-[10px] font-black uppercase tracking-widest border-b border-l ${t.border} group-hover:bg-orange-500 group-hover:text-white group-hover:border-orange-500 transition-colors`}
                                        >
                                            {device.vendor}
                                        </div>
                                        <h4
                                            className={`font-heading text-2xl font-black ${t.textMain} mt-4 mb-3 tracking-wide pr-16 group-hover:text-orange-500 transition-colors`}
                                        >
                                            {device.model}
                                        </h4>
                                        <div className="flex flex-wrap gap-2 mb-6">
                                            <span
                                                className={`text-[10px] font-bold tracking-widest px-2 py-1 border ${device.type === "KOLOR" ? "border-blue-500/50 text-blue-500 bg-blue-500/5" : `${t.border} ${t.textSecondary}`}`}
                                            >
                                                {device.type}
                                            </span>
                                            <span
                                                className={`text-[10px] font-bold tracking-widest px-2 py-1 border ${t.border} ${t.textSecondary}`}
                                            >
                                                {device.format}
                                            </span>
                                            <span
                                                className={`text-[10px] font-bold tracking-widest px-2 py-1 border ${t.border} ${t.textSecondary}`}
                                            >
                                                {device.kind}
                                            </span>
                                        </div>
                                        <div
                                            className={`mt-auto border-t ${t.border} pt-5`}
                                        >
                                            <div className="flex justify-between items-center mb-4">
                                                <span
                                                    className={`text-[10px] uppercase tracking-widest font-bold ${t.textSecondary}`}
                                                >
                                                    Abonament <br />
                                                    (60 mc)
                                                </span>
                                                <div className="text-right">
                                                    <span
                                                        className={`font-heading text-3xl font-black ${t.textMain}`}
                                                    >
                                                        {device.lease}
                                                    </span>
                                                    <span
                                                        className={`text-[10px] ${t.textSecondary} ml-1`}
                                                    >
                                                        zł/mc
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className={`grid grid-cols-2 gap-2`}
                                            >
                                                <div
                                                    className={`flex flex-col items-center justify-center ${t.bgSection} p-3 border ${t.border}`}
                                                >
                                                    <span
                                                        className={`text-[9px] uppercase tracking-widest font-bold ${t.textSecondary} mb-1`}
                                                    >
                                                        Klik Mono
                                                    </span>
                                                    <span
                                                        className={`text-sm font-bold ${t.textMain}`}
                                                    >
                                                        {device.clickMono} gr
                                                    </span>
                                                </div>
                                                <div
                                                    className={`flex flex-col items-center justify-center ${t.bgSection} p-3 border ${t.border}`}
                                                >
                                                    <span
                                                        className={`text-[9px] uppercase tracking-widest font-bold ${t.textSecondary} mb-1`}
                                                    >
                                                        Klik Kolor
                                                    </span>
                                                    <span
                                                        className={`text-sm font-bold ${device.clickColor ? t.textMain : t.textSecondary}`}
                                                    >
                                                        {device.clickColor
                                                            ? `${device.clickColor} gr`
                                                            : "---"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="absolute bottom-0 left-0 w-0 h-1 bg-orange-500 group-hover:w-full transition-all duration-500"
                                            aria-hidden="true"
                                        ></div>
                                    </article>
                                ))}
                                {filteredDevices.length === 0 && (
                                    <div className="col-span-full py-12 text-center text-zinc-500 uppercase tracking-widest font-bold text-sm">
                                        Brak urządzeń spełniających wybrane
                                        kryteria.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                <div
                    className={`w-full h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent relative z-10`}
                    aria-hidden="true"
                ></div>

                <section
                    id="oprogramowanie"
                    aria-labelledby="software-title"
                    className={`py-32 ${t.bgBase} relative`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-20 grid lg:grid-cols-2 gap-12 items-end reveal">
                            <div>
                                <h2
                                    id="software-title"
                                    className={`font-heading text-5xl md:text-6xl font-black tracking-tighter ${t.textMain} uppercase mb-6`}
                                >
                                    Inteligentny <br />
                                    <span className="text-orange-500">
                                        Ekosystem.
                                    </span>
                                </h2>
                                <p
                                    className={`text-xl ${t.textSecondary} font-light`}
                                >
                                    Sprzęt to połowa sukcesu. Prawdziwą
                                    optymalizację osiągamy wdrażając
                                    zaawansowane oprogramowanie.
                                </p>
                            </div>
                        </div>

                        <div className="grid md:grid-cols-2 gap-8">
                            <article
                                className={`border ${t.border} ${t.bgSection} p-12 relative overflow-hidden group hover:border-blue-500 transition-colors reveal delay-100`}
                            >
                                <div className="flex justify-between items-start mb-12">
                                    <Shield
                                        className="w-12 h-12 text-blue-500"
                                        strokeWidth={1}
                                        aria-hidden="true"
                                    />
                                    <span
                                        className={`text-[10px] font-bold uppercase tracking-[0.3em] ${t.textSecondary} border ${t.border} px-3 py-1`}
                                    >
                                        Wydruk Podążający
                                    </span>
                                </div>
                                <h3
                                    className={`font-heading text-3xl font-black ${t.textMain} mb-4 uppercase tracking-widest`}
                                >
                                    SafeQ
                                </h3>
                                <p
                                    className={`${t.textSecondary} mb-8 leading-relaxed font-light text-sm`}
                                >
                                    Rozwiązanie YSoft SafeQ sprzęga autoryzację
                                    z flotą maszyn. Logowanie kartą zbliżeniową
                                    (RFID) przy urządzeniu eliminuje ryzyko
                                    dostępu do poufnych dokumentów przez osoby
                                    niepowołane.
                                </p>
                            </article>

                            <article
                                className={`border ${t.border} ${t.bgSection} p-12 relative overflow-hidden group hover:border-orange-500 transition-colors reveal delay-200`}
                            >
                                <div className="flex justify-between items-start mb-12">
                                    <Activity
                                        className="w-12 h-12 text-orange-500"
                                        strokeWidth={1}
                                        aria-hidden="true"
                                    />
                                    <span
                                        className={`text-[10px] font-bold uppercase tracking-[0.3em] ${t.textSecondary} border ${t.border} px-3 py-1`}
                                    >
                                        Zdalny Monitoring
                                    </span>
                                </div>
                                <h3
                                    className={`font-heading text-3xl font-black ${t.textMain} mb-4 uppercase tracking-widest`}
                                >
                                    Princity
                                </h3>
                                <p
                                    className={`${t.textSecondary} mb-8 leading-relaxed font-light text-sm`}
                                >
                                    System zarządzania flotą w czasie
                                    rzeczywistym. W chmurze analizujemy odczyty
                                    liczników i prognozujemy zużycie. Zamawiamy
                                    tonery zanim zauważysz ich brak.
                                </p>
                            </article>
                        </div>
                    </div>
                </section>

                <div
                    className={`w-full h-px bg-gradient-to-r from-transparent via-zinc-500/30 to-transparent relative z-10`}
                    aria-hidden="true"
                ></div>

                <section
                    id="faq"
                    aria-labelledby="faq-title"
                    className={`py-32 ${t.bgSection} relative`}
                >
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-20 text-center reveal">
                            <h2
                                id="faq-title"
                                className={`font-heading text-5xl md:text-6xl font-black tracking-tighter ${t.textMain} uppercase mb-6`}
                            >
                                Baza{" "}
                                <span className="text-orange-500">Wiedzy.</span>
                            </h2>
                            <p
                                className={`text-xl ${t.textSecondary} font-light`}
                            >
                                Najczęściej zadawane pytania dotyczące wdrożeń
                                zarządzanego druku (MPS).
                            </p>
                        </div>
                        <div className="space-y-4 reveal delay-100">
                            {faqs.map((faq, idx) => (
                                <div
                                    key={idx}
                                    className={`border ${t.border} ${t.bgBase} transition-all duration-300 ${activeFaq === idx ? "border-orange-500" : "hover:border-zinc-500"}`}
                                >
                                    <button
                                        onClick={() =>
                                            setActiveFaq(
                                                activeFaq === idx ? null : idx,
                                            )
                                        }
                                        className={`w-full flex items-center justify-between p-6 md:p-8 text-left outline-none cursor-pointer focus:ring-2 focus:ring-inset focus:ring-orange-500`}
                                        aria-expanded={activeFaq === idx}
                                    >
                                        <span
                                            className={`text-sm md:text-base font-bold uppercase tracking-widest ${activeFaq === idx ? "text-orange-500" : t.textMain} transition-colors pr-8 leading-relaxed`}
                                        >
                                            {faq.q}
                                        </span>
                                        <div
                                            className={`flex-shrink-0 w-8 h-8 flex items-center justify-center border ${activeFaq === idx ? "border-orange-500 bg-orange-500 text-white" : `${t.border} ${t.textSecondary}`} transition-all`}
                                            aria-hidden="true"
                                        >
                                            {activeFaq === idx ? (
                                                <Minus className="w-4 h-4" />
                                            ) : (
                                                <Plus className="w-4 h-4" />
                                            )}
                                        </div>
                                    </button>
                                    <div
                                        className={`overflow-hidden transition-all duration-300 ease-in-out ${activeFaq === idx ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
                                        aria-hidden={activeFaq !== idx}
                                    >
                                        <p
                                            className={`p-6 md:p-8 pt-0 text-sm md:text-base ${t.textSecondary} leading-relaxed font-light border-t border-transparent`}
                                        >
                                            {faq.a}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>

            {isContactOpen && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-title"
                    className="fixed inset-0 z-[100] flex items-center justify-center sm:p-6 overflow-hidden"
                >
                    <div
                        className={`absolute inset-0 ${isDarkMode ? "bg-black/80" : "bg-zinc-200/80"} backdrop-blur-2xl`}
                        onClick={() => setIsContactOpen(false)}
                        aria-hidden="true"
                    ></div>

                    <div
                        className="absolute top-0 left-1/4 w-[50vw] h-[50vw] bg-blue-600/30 rounded-full blur-[150px] animate-blob pointer-events-none"
                        aria-hidden="true"
                    ></div>
                    <div
                        className="absolute bottom-0 right-1/4 w-[40vw] h-[40vw] bg-orange-500/20 rounded-full blur-[150px] animate-blob animation-delay-2000 pointer-events-none"
                        aria-hidden="true"
                    ></div>

                    <div
                        className={`relative w-full h-full sm:h-auto sm:max-h-[95vh] max-w-6xl overflow-y-auto ${isDarkMode ? "bg-zinc-950 sm:bg-zinc-950/60" : "bg-white sm:bg-white/90"} sm:backdrop-blur-xl sm:shadow-[0_0_80px_rgba(0,0,0,0.8)] flex flex-col md:flex-row border-0 sm:border ${isDarkMode ? "border-white/10" : "border-zinc-200"} rounded-none sm:rounded-2xl`}
                    >
                        <button
                            aria-label="Zamknij"
                            onClick={() => setIsContactOpen(false)}
                            className={`fixed top-4 right-4 sm:absolute sm:top-6 sm:right-6 z-[110] p-2 ${isDarkMode ? "bg-zinc-900 sm:bg-white/10 border-zinc-700 sm:border-white/20 text-white" : "bg-white sm:bg-black/5 border-zinc-200 sm:border-black/10 text-black"} backdrop-blur-md rounded-full border hover:bg-orange-500 hover:border-orange-500 hover:text-white hover:scale-110 transition-all shadow-xl focus:outline-none focus:ring-2 focus:ring-orange-500`}
                        >
                            <X className="w-5 h-5" aria-hidden="true" />
                        </button>

                        <div
                            className={`w-full md:w-5/12 p-6 pt-20 sm:pt-6 md:p-10 xl:p-12 flex flex-col justify-between border-b md:border-b-0 md:border-r ${isDarkMode ? "border-white/10" : "border-zinc-200"} relative overflow-hidden shrink-0`}
                        >
                            <div className="relative z-10 pt-4 md:pt-0 h-full flex flex-col">
                                <div>
                                    <h2
                                        id="modal-title"
                                        className={`font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter ${t.textMain} mb-2 uppercase leading-none`}
                                    >
                                        Porozmawiajmy
                                    </h2>
                                    <p className="text-blue-500 font-bold uppercase tracking-widest text-xs mb-10">
                                        Rozpocznij transformację
                                    </p>
                                </div>

                                {contactContext && (
                                    <div
                                        className={`mb-12 p-6 md:p-8 border ${isDarkMode ? "border-white/10 bg-white/5" : "border-blue-500/20 bg-blue-50"} relative overflow-hidden rounded-xl shadow-[0_0_30px_rgba(37,99,235,0.05)]`}
                                    >
                                        <div
                                            className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-cyan-400"
                                            aria-hidden="true"
                                        ></div>
                                        <h4
                                            className={`text-[10px] uppercase tracking-[0.2em] font-bold ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} mb-6 flex items-center`}
                                        >
                                            <FileCheck
                                                className="w-4 h-4 mr-2 text-cyan-500"
                                                aria-hidden="true"
                                            />{" "}
                                            Twój Kontekst
                                        </h4>

                                        {contactContext.type ===
                                            "calculator" && (
                                            <div>
                                                <p
                                                    className={`font-heading text-2xl font-black ${t.textMain} mb-2 leading-tight uppercase`}
                                                >
                                                    {
                                                        contactContext.device
                                                            .vendor
                                                    }{" "}
                                                    <br />
                                                    <span className="text-blue-500">
                                                        {
                                                            contactContext
                                                                .device.model
                                                        }
                                                    </span>
                                                </p>
                                                <div className="grid grid-cols-2 gap-4 my-6">
                                                    <div>
                                                        <p
                                                            className={`text-[9px] uppercase tracking-widest ${isDarkMode ? "text-zinc-500" : "text-zinc-400"}`}
                                                        >
                                                            Wolumen Mono
                                                        </p>
                                                        <p
                                                            className={`font-bold ${t.textMain} text-lg`}
                                                        >
                                                            {
                                                                contactContext.monoPages
                                                            }{" "}
                                                            <span
                                                                className={`text-xs ${isDarkMode ? "text-zinc-500" : "text-zinc-400"} font-normal`}
                                                            >
                                                                str.
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p
                                                            className={`text-[9px] uppercase tracking-widest ${isDarkMode ? "text-zinc-500" : "text-zinc-400"}`}
                                                        >
                                                            Wolumen Kolor
                                                        </p>
                                                        <p
                                                            className={`font-bold ${t.textMain} text-lg`}
                                                        >
                                                            {
                                                                contactContext.colorPages
                                                            }{" "}
                                                            <span
                                                                className={`text-xs ${isDarkMode ? "text-zinc-500" : "text-zinc-400"} font-normal`}
                                                            >
                                                                str.
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className={`border-t ${isDarkMode ? "border-white/10" : "border-zinc-200"} pt-4 mt-2`}
                                                >
                                                    <p
                                                        className={`text-[9px] uppercase tracking-widest ${isDarkMode ? "text-zinc-500" : "text-zinc-400"} mb-1`}
                                                    >
                                                        Estymacja miesięczna
                                                        netto
                                                    </p>
                                                    <p
                                                        className={`font-heading text-3xl font-black text-orange-500`}
                                                    >
                                                        {contactContext.totalCost.toFixed(
                                                            2,
                                                        )}{" "}
                                                        zł
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {contactContext.type === "device" && (
                                            <div>
                                                <p
                                                    className={`font-heading text-2xl font-black ${t.textMain} mb-2 leading-tight uppercase`}
                                                >
                                                    {
                                                        contactContext.device
                                                            .vendor
                                                    }{" "}
                                                    <br />
                                                    <span className="text-blue-500">
                                                        {
                                                            contactContext
                                                                .device.model
                                                        }
                                                    </span>
                                                </p>
                                                <p
                                                    className={`text-sm ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} mb-6 font-light`}
                                                >
                                                    Wycena wariantu
                                                    dedykowanego.
                                                </p>
                                                <div
                                                    className={`border-t ${isDarkMode ? "border-white/10" : "border-zinc-200"} pt-4 mt-2`}
                                                >
                                                    <p
                                                        className={`text-[9px] uppercase tracking-widest ${isDarkMode ? "text-zinc-500" : "text-zinc-400"} mb-1`}
                                                    >
                                                        Abonament od
                                                    </p>
                                                    <p
                                                        className={`font-heading text-3xl font-black text-orange-500`}
                                                    >
                                                        {
                                                            contactContext
                                                                .device.lease
                                                        }{" "}
                                                        zł{" "}
                                                        <span
                                                            className={`text-xs font-sans ${isDarkMode ? "text-zinc-500" : "text-zinc-400"} uppercase tracking-widest font-bold`}
                                                        >
                                                            /mc
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="space-y-6 mt-auto">
                                    <div className="flex items-center group">
                                        <div
                                            className={`w-12 h-12 rounded-full border ${isDarkMode ? "border-white/10 bg-white/5" : "border-zinc-200 bg-white"} flex items-center justify-center mr-4 group-hover:bg-blue-600 group-hover:border-blue-500 transition-all duration-300`}
                                            aria-hidden="true"
                                        >
                                            <Mail className="w-5 h-5 text-blue-500 group-hover:text-white transition-colors" />
                                        </div>
                                        <div>
                                            <p
                                                className={`text-[9px] uppercase tracking-widest ${isDarkMode ? "text-zinc-500" : "text-zinc-400"} mb-1`}
                                            >
                                                Napisz do nas
                                            </p>
                                            <a
                                                href="mailto:kontakt@pixelprintshop.pl"
                                                className={`font-heading text-lg font-bold ${t.textMain} group-hover:text-blue-500 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                            >
                                                kontakt@pixelprintshop.pl
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`w-full md:w-7/12 p-6 md:p-10 xl:p-12 relative flex flex-col justify-center`}
                        >
                            {formStatus === "success" ? (
                                <div className="text-center animate-in fade-in zoom-in duration-500">
                                    <div
                                        className="w-24 h-24 mx-auto mb-6 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-[0_0_40px_rgba(52,211,153,0.4)]"
                                        aria-hidden="true"
                                    >
                                        <CheckCircle2 className="w-12 h-12 text-white" />
                                    </div>
                                    <h3
                                        className={`font-heading text-4xl font-black ${t.textMain} mb-4 uppercase`}
                                    >
                                        Sukces!
                                    </h3>
                                    <p
                                        className={`${t.textSecondary} text-lg leading-relaxed`}
                                    >
                                        Twoje zapytanie wylądowało w naszym
                                        systemie. <br /> Odezwiemy się do Ciebie
                                        z wyceną najszybciej jak to możliwe.
                                    </p>
                                </div>
                            ) : formStatus === "error" ? (
                                <div className="text-center animate-in fade-in zoom-in duration-500">
                                    <div
                                        className="w-24 h-24 mx-auto mb-6 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center shadow-[0_0_40px_rgba(239,68,68,0.4)]"
                                        aria-hidden="true"
                                    >
                                        <X className="w-12 h-12 text-white" />
                                    </div>
                                    <h3
                                        className={`font-heading text-4xl font-black ${t.textMain} mb-4 uppercase`}
                                    >
                                        Wystąpił błąd
                                    </h3>
                                    <p
                                        className={`${t.textSecondary} text-lg leading-relaxed mb-8`}
                                    >
                                        Nie udało się wysłać zapytania. Sprawdź
                                        swoje połączenie sieciowe lub spróbuj
                                        ponownie.
                                    </p>
                                    <button
                                        onClick={() => setFormStatus("idle")}
                                        className={`px-8 py-4 bg-orange-500 text-white text-sm uppercase tracking-widest font-bold hover:bg-orange-400 transition-colors rounded-xl shadow-[0_0_20px_rgba(249,115,22,0.3)] focus:outline-none focus:ring-2 focus:ring-orange-500`}
                                    >
                                        Spróbuj ponownie
                                    </button>
                                </div>
                            ) : (
                                <form
                                    className="space-y-8 flex flex-col justify-center animate-in fade-in"
                                    onSubmit={handleFormSubmit}
                                >
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                                        <div className="relative z-0 w-full group">
                                            <input
                                                type="text"
                                                name="contact_name"
                                                id="contact_name"
                                                className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-orange-500 peer transition-colors rounded-none`}
                                                placeholder=" "
                                                required
                                                disabled={
                                                    formStatus === "submitting"
                                                }
                                            />
                                            <label
                                                htmlFor="contact_name"
                                                className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-orange-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                            >
                                                Imię i Nazwisko *
                                            </label>
                                        </div>
                                        <div className="relative z-0 w-full group">
                                            <input
                                                type="text"
                                                name="contact_company"
                                                id="contact_company"
                                                className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-blue-500 peer transition-colors rounded-none`}
                                                placeholder=" "
                                                disabled={
                                                    formStatus === "submitting"
                                                }
                                            />
                                            <label
                                                htmlFor="contact_company"
                                                className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                            >
                                                Nazwa Firmy / NIP
                                            </label>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-6">
                                        <div className="relative z-0 w-full group">
                                            <input
                                                type="email"
                                                name="contact_email"
                                                id="contact_email"
                                                className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-orange-500 peer transition-colors rounded-none`}
                                                placeholder=" "
                                                required
                                                disabled={
                                                    formStatus === "submitting"
                                                }
                                            />
                                            <label
                                                htmlFor="contact_email"
                                                className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-orange-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                            >
                                                Adres E-mail *
                                            </label>
                                        </div>
                                        <div className="relative z-0 w-full group">
                                            <input
                                                type="tel"
                                                name="contact_phone"
                                                id="contact_phone"
                                                className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-blue-500 peer transition-colors rounded-none`}
                                                placeholder=" "
                                                required
                                                disabled={
                                                    formStatus === "submitting"
                                                }
                                            />
                                            <label
                                                htmlFor="contact_phone"
                                                className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                            >
                                                Telefon Kontaktowy *
                                            </label>
                                        </div>
                                    </div>

                                    <div className="relative z-0 w-full group mt-6">
                                        <input
                                            type="text"
                                            name="contact_location"
                                            id="contact_location"
                                            className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-orange-500 peer transition-colors rounded-none`}
                                            placeholder=" "
                                            disabled={
                                                formStatus === "submitting"
                                            }
                                        />
                                        <label
                                            htmlFor="contact_location"
                                            className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-orange-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                        >
                                            Miejscowość instalacji maszyn
                                        </label>
                                    </div>

                                    {(!contactContext ||
                                        contactContext.type !==
                                            "calculator") && (
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-6">
                                            <div className="relative z-0 w-full group">
                                                <select
                                                    name="contact_mono"
                                                    id="contact_mono"
                                                    className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-orange-500 peer transition-colors cursor-pointer rounded-none relative z-10`}
                                                    required
                                                    defaultValue=""
                                                    disabled={
                                                        formStatus ===
                                                        "submitting"
                                                    }
                                                >
                                                    <option
                                                        value=""
                                                        disabled
                                                        hidden
                                                    ></option>
                                                    <option
                                                        value="<1000"
                                                        className={t.bgBase}
                                                    >
                                                        Mniej niż 1000 str.
                                                    </option>
                                                    <option
                                                        value="1000-5000"
                                                        className={t.bgBase}
                                                    >
                                                        1000 - 5000 str.
                                                    </option>
                                                    <option
                                                        value="5000-10000"
                                                        className={t.bgBase}
                                                    >
                                                        5000 - 10000 str.
                                                    </option>
                                                    <option
                                                        value=">10000"
                                                        className={t.bgBase}
                                                    >
                                                        Powyżej 10000 str.
                                                    </option>
                                                    <option
                                                        value="audit"
                                                        className={`font-bold text-orange-500 ${t.bgBase}`}
                                                    >
                                                        Potrzebuję audytu
                                                    </option>
                                                </select>
                                                <label
                                                    htmlFor="contact_mono"
                                                    className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-orange-500 peer-valid:scale-75 peer-valid:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                                >
                                                    Wolumen Mono / mc
                                                </label>
                                                <ChevronDown
                                                    className={`absolute right-0 top-3 w-5 h-5 pointer-events-none ${isDarkMode ? "text-zinc-500" : "text-zinc-400"}`}
                                                    aria-hidden="true"
                                                />
                                            </div>

                                            <div className="relative z-0 w-full group">
                                                <select
                                                    name="contact_color"
                                                    id="contact_color"
                                                    className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-blue-500 peer transition-colors cursor-pointer rounded-none relative z-10`}
                                                    required
                                                    defaultValue=""
                                                    disabled={
                                                        formStatus ===
                                                        "submitting"
                                                    }
                                                >
                                                    <option
                                                        value=""
                                                        disabled
                                                        hidden
                                                    ></option>
                                                    <option
                                                        value="0"
                                                        className={t.bgBase}
                                                    >
                                                        Brak / Znikomy
                                                    </option>
                                                    <option
                                                        value="<1000"
                                                        className={t.bgBase}
                                                    >
                                                        Do 1000 str.
                                                    </option>
                                                    <option
                                                        value="1000-3000"
                                                        className={t.bgBase}
                                                    >
                                                        1000 - 3000 str.
                                                    </option>
                                                    <option
                                                        value=">3000"
                                                        className={t.bgBase}
                                                    >
                                                        Powyżej 3000 str.
                                                    </option>
                                                    <option
                                                        value="audit"
                                                        className={`font-bold text-blue-500 ${t.bgBase}`}
                                                    >
                                                        Potrzebuję audytu
                                                    </option>
                                                </select>
                                                <label
                                                    htmlFor="contact_color"
                                                    className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-500 peer-valid:scale-75 peer-valid:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                                >
                                                    Wolumen Kolor / mc
                                                </label>
                                                <ChevronDown
                                                    className={`absolute right-0 top-3 w-5 h-5 pointer-events-none ${isDarkMode ? "text-zinc-500" : "text-zinc-400"}`}
                                                    aria-hidden="true"
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="relative z-0 w-full group mt-6">
                                        <textarea
                                            name="contact_message"
                                            id="contact_message"
                                            rows="3"
                                            className={`block py-2.5 px-0 w-full text-lg ${t.textMain} bg-transparent border-0 border-b-2 ${isDarkMode ? "border-zinc-600" : "border-zinc-300"} appearance-none focus:outline-none focus:ring-0 focus:border-orange-500 peer transition-colors resize-none rounded-none`}
                                            placeholder=" "
                                            disabled={
                                                formStatus === "submitting"
                                            }
                                        ></textarea>
                                        <label
                                            htmlFor="contact_message"
                                            className={`peer-focus:font-bold absolute ${isDarkMode ? "text-zinc-400" : "text-zinc-500"} duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-orange-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 uppercase tracking-widest text-xs font-bold`}
                                        >
                                            Wiadomość / Dodatkowe informacje
                                        </label>
                                    </div>

                                    <div className="flex items-start mt-6">
                                        <div className="flex items-center h-5 mt-0.5">
                                            <input
                                                id="rodo_consent"
                                                type="checkbox"
                                                required
                                                disabled={
                                                    formStatus === "submitting"
                                                }
                                                className={`w-4 h-4 rounded-sm border ${isDarkMode ? "border-zinc-600 bg-transparent" : "border-zinc-400 bg-white"} text-orange-500 focus:ring-orange-500 focus:ring-2 cursor-pointer`}
                                            />
                                        </div>
                                        <label
                                            htmlFor="rodo_consent"
                                            className={`ml-3 text-[10px] ${t.textSecondary} leading-relaxed`}
                                        >
                                            Wyrażam zgodę na przetwarzanie
                                            podanych danych w celu przygotowania
                                            oferty. Akceptuję{" "}
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setLegalModal("policy")
                                                }
                                                className="text-blue-500 hover:text-blue-400 underline outline-none focus:ring-2 focus:ring-orange-500"
                                            >
                                                Politykę Prywatności
                                            </button>
                                            . *
                                        </label>
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={formStatus === "submitting"}
                                        className={`relative w-full py-5 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-sm uppercase tracking-[0.2em] font-black transition-all mt-8 flex justify-center items-center group overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-900 ${formStatus === "submitting" ? "opacity-80 cursor-wait" : "hover:from-orange-500 hover:to-orange-400 shadow-[0_0_30px_rgba(37,99,235,0.4)] hover:shadow-[0_0_50px_rgba(249,115,22,0.6)]"}`}
                                    >
                                        <div
                                            className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out"
                                            aria-hidden="true"
                                        ></div>
                                        <span className="relative flex items-center">
                                            {formStatus === "submitting" ? (
                                                <>Przetwarzanie...</>
                                            ) : (
                                                <>
                                                    Wyślij Zapytanie{" "}
                                                    <Sparkles
                                                        className="w-5 h-5 ml-3 group-hover:rotate-12 group-hover:scale-125 transition-all duration-300"
                                                        aria-hidden="true"
                                                    />
                                                </>
                                            )}
                                        </span>
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {selectedDevice && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-label={`Szczegóły modelu ${selectedDevice.model}`}
                    className="fixed inset-0 z-[100] flex items-center justify-center sm:p-6"
                >
                    <div
                        className="absolute inset-0 bg-black/80 backdrop-blur-md"
                        onClick={() => setSelectedDevice(null)}
                        aria-hidden="true"
                    ></div>

                    <div
                        className={`relative w-full h-full sm:h-auto sm:max-h-[90vh] max-w-5xl overflow-y-auto ${t.bgBase} border-0 sm:border ${t.border} sm:shadow-[0_0_50px_rgba(0,0,0,0.5)] flex flex-col md:flex-row mt-0 sm:rounded-2xl`}
                    >
                        <button
                            aria-label="Zamknij podgląd urządzenia"
                            onClick={() => setSelectedDevice(null)}
                            className={`fixed top-4 right-4 sm:absolute sm:top-4 sm:right-4 z-[110] p-3 border transition-colors shadow-xl focus:outline-none focus:ring-2 focus:ring-orange-500 rounded-full sm:rounded-none ${isDarkMode ? "bg-zinc-900 sm:bg-transparent border-zinc-700 sm:border-transparent text-white hover:bg-orange-500 hover:border-orange-500" : "bg-white sm:bg-transparent border-zinc-300 sm:border-transparent text-black hover:bg-orange-500 hover:text-white hover:border-orange-500"}`}
                        >
                            <X className="w-6 h-6" aria-hidden="true" />
                        </button>

                        <div
                            className={`w-full md:w-5/12 ${t.bgSection} border-b md:border-b-0 md:border-r ${t.border} p-6 pt-20 sm:pt-6 md:p-8 flex items-center justify-center min-h-[300px]`}
                        >
                            <div
                                className={`text-center ${isDarkMode ? "text-zinc-500 border-zinc-500/50 bg-black/20" : "text-zinc-400 border-zinc-300 bg-black/5"} font-bold uppercase tracking-widest text-sm border border-dashed p-8 md:p-12 w-full h-full flex flex-col items-center justify-center`}
                            >
                                <Printer
                                    className="w-20 h-20 mb-6 opacity-30 text-blue-500"
                                    strokeWidth={1}
                                    aria-hidden="true"
                                />
                                <span className="opacity-50">
                                    [Obraz urządzenia {selectedDevice.vendor}{" "}
                                    {selectedDevice.model}]
                                </span>
                            </div>
                        </div>

                        <div
                            className={`w-full md:w-7/12 p-6 md:p-12 relative flex flex-col`}
                        >
                            <h3
                                className={`text-[10px] font-bold uppercase tracking-[0.3em] ${t.textSecondary} mb-2`}
                            >
                                {selectedDevice.vendor}
                            </h3>
                            <h2
                                className={`font-heading text-3xl font-black ${t.textMain} mb-6 tracking-wide uppercase`}
                            >
                                {selectedDevice.model}
                            </h2>

                            <div className="flex flex-wrap gap-2 mb-10">
                                <span
                                    className={`text-[10px] font-bold tracking-widest px-2 py-1 border ${selectedDevice.type === "KOLOR" ? "border-blue-500/50 text-blue-500 bg-blue-500/5" : `${t.border} ${t.textSecondary}`}`}
                                >
                                    {selectedDevice.type}
                                </span>
                                <span
                                    className={`text-[10px] font-bold tracking-widest px-2 py-1 border ${t.border} ${t.textSecondary}`}
                                >
                                    {selectedDevice.format}
                                </span>
                                <span
                                    className={`text-[10px] font-bold tracking-widest px-2 py-1 border ${t.border} ${t.textSecondary}`}
                                >
                                    {selectedDevice.kind}
                                </span>
                            </div>

                            <div className="grid grid-cols-2 gap-3 mb-10">
                                {Object.entries(selectedDevice.specs).map(
                                    ([key, value]) => {
                                        const labels = {
                                            speed: "Prędkość druku",
                                            resolution: "Rozdzielczość",
                                            memory: "Pamięć / Dysk",
                                            paper: "Podajniki (Std)",
                                            panel: "Ekran / Panel",
                                            extra: "Cechy kluczowe",
                                        };
                                        return (
                                            <div
                                                key={key}
                                                className={`p-4 ${t.bgSection} border ${t.border}`}
                                            >
                                                <div
                                                    className={`text-[9px] uppercase tracking-widest font-bold ${t.textSecondary} mb-1.5`}
                                                >
                                                    {labels[key]}
                                                </div>
                                                <div
                                                    className={`text-xs font-bold ${t.textMain} leading-snug`}
                                                >
                                                    {value}
                                                </div>
                                            </div>
                                        );
                                    },
                                )}
                            </div>

                            <div className="mt-auto space-y-4 pt-6 border-t border-zinc-800/50">
                                <div
                                    className={`flex justify-between items-center`}
                                >
                                    <span
                                        className={`text-[10px] font-bold uppercase tracking-[0.2em] ${t.textSecondary}`}
                                    >
                                        Rata Dzierżawy (60 mc)
                                    </span>
                                    <span
                                        className={`font-heading text-2xl font-black ${t.textMain}`}
                                    >
                                        {selectedDevice.lease}{" "}
                                        <span className="text-xs font-sans font-normal text-zinc-500 uppercase">
                                            zł/mc
                                        </span>
                                    </span>
                                </div>
                                <div
                                    className={`flex justify-between items-center`}
                                >
                                    <span
                                        className={`text-[10px] font-bold uppercase tracking-[0.2em] ${t.textSecondary}`}
                                    >
                                        Koszt Klik Mono
                                    </span>
                                    <span
                                        className={`text-sm font-bold ${t.textMain}`}
                                    >
                                        {selectedDevice.clickMono} gr
                                    </span>
                                </div>
                                {selectedDevice.type === "KOLOR" && (
                                    <div
                                        className={`flex justify-between items-center`}
                                    >
                                        <span
                                            className={`text-[10px] font-bold uppercase tracking-[0.2em] ${t.textSecondary}`}
                                        >
                                            Koszt Klik Kolor
                                        </span>
                                        <span
                                            className={`text-sm font-bold ${t.textMain}`}
                                        >
                                            {selectedDevice.clickColor} gr
                                        </span>
                                    </div>
                                )}
                            </div>

                            <button
                                onClick={() => {
                                    openContactWithContext("device", {
                                        device: selectedDevice,
                                    });
                                    setSelectedDevice(null);
                                }}
                                className={`w-full py-4 mt-8 bg-blue-600 text-white text-sm uppercase tracking-[0.2em] font-black hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                            >
                                Zapytaj o ten model
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {legalModal && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="legal-title"
                    className="fixed inset-0 z-[200] flex items-center justify-center sm:p-6"
                >
                    <div
                        className="absolute inset-0 bg-black/90 backdrop-blur-sm"
                        onClick={() => setLegalModal(null)}
                        aria-hidden="true"
                    ></div>
                    <div
                        className={`relative w-full h-full sm:h-auto sm:max-h-[90vh] max-w-4xl overflow-y-auto ${t.bgCard} border-0 sm:border ${t.border} p-6 pt-20 sm:p-8 md:p-12 sm:shadow-2xl sm:rounded-2xl brutalist-scrollbar`}
                    >
                        <button
                            aria-label="Zamknij dokument"
                            onClick={() => setLegalModal(null)}
                            className={`fixed top-4 right-4 sm:absolute sm:top-6 sm:right-6 z-[110] p-3 sm:p-2 bg-zinc-800 hover:bg-orange-500 text-white transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 rounded-full sm:rounded-none`}
                        >
                            <X aria-hidden="true" />
                        </button>

                        <h2
                            id="legal-title"
                            className={`font-heading text-3xl font-black uppercase mb-8 ${t.textMain}`}
                        >
                            {legalModal === "policy" && "Polityka Prywatności"}
                            {legalModal === "terms" &&
                                "Regulamin Świadczenia Usług (MPS)"}
                            {legalModal === "rodo" &&
                                "Klauzula Informacyjna RODO"}
                        </h2>

                        <div
                            className={`space-y-6 text-sm ${t.textSecondary} leading-relaxed`}
                        >
                            {legalModal === "policy" && (
                                <>
                                    <p>
                                        <strong className={t.textMain}>
                                            1. Administrator Danych
                                        </strong>
                                        <br />
                                        Administratorem danych osobowych
                                        gromadzonych za pośrednictwem serwisu
                                        PixelPrintShop jest PixelPrintShop.
                                        Ochrona danych odbywa się zgodnie z
                                        wymogami powszechnie obowiązujących
                                        przepisów prawa, a ich przechowywanie ma
                                        miejsce na zabezpieczonych serwerach.
                                    </p>
                                    <p>
                                        <strong className={t.textMain}>
                                            2. Zakres zbieranych danych
                                        </strong>
                                        <br />W ramach formularzy zapytania
                                        ofertowego i kalkulatora zbieramy dane
                                        niezbędne do przygotowania dedykowanej
                                        wyceny dzierżawy: imię i nazwisko, adres
                                        e-mail, numer telefonu oraz opcjonalnie
                                        nazwę firmy i NIP.
                                    </p>
                                    <p>
                                        <strong className={t.textMain}>
                                            3. Telemetria i Systemy Zarządzania
                                            Drukiem
                                        </strong>
                                        <br />W ramach świadczonych usług
                                        dzierżawy MPS instalowane są na
                                        urządzeniach aplikacje telemetryczne
                                        (np. Princity, SafeQ). Systemy te
                                        przekazują wyłącznie dane eksploatacyjne
                                        (stan liczników, poziom tonerów, logi
                                        błędów). Administrator{" "}
                                        <strong className="text-orange-500">
                                            nie ma wglądu w treść
                                        </strong>{" "}
                                        drukowanych, skanowanych ani kopiowanych
                                        dokumentów.
                                    </p>
                                    <p>
                                        <strong className={t.textMain}>
                                            4. Pliki cookies
                                        </strong>
                                        <br />
                                        Witryna pixelprintshop.pl używa cookies.
                                        Są to niewielkie pliki tekstowe wysyłane
                                        przez serwer www i przechowywane przez
                                        oprogramowanie komputera przeglądarki.
                                        Wykorzystujemy cookies w celach
                                        funkcjonalnych, w tym do zapamiętywania
                                        decyzji o akceptacji polityki.
                                    </p>
                                </>
                            )}

                            {legalModal === "terms" && (
                                <>
                                    <p>
                                        <strong className={t.textMain}>
                                            1. Postanowienia Ogólne
                                        </strong>
                                        <br />
                                        Niniejszy regulamin określa ogólne
                                        zasady, na jakich PixelPrintShop
                                        świadczy usługi dzierżawy urządzeń
                                        wielofunkcyjnych i drukarek, w modelu
                                        Managed Print Services (MPS) dla
                                        podmiotów biznesowych (B2B).
                                    </p>
                                    <p>
                                        <strong className={t.textMain}>
                                            2. Model Rozliczeń "Per Page"
                                        </strong>
                                        <br />
                                        Dzierżawa urządzenia opiera się na
                                        stałej miesięcznej opłacie abonamentowej
                                        oraz opłacie za każdą faktycznie
                                        wydrukowaną stronę (tzw. "Klik"). Koszt
                                        klika obejmuje wszystkie materiały
                                        eksploatacyjne (tonery, bębny, pasy
                                        transferowe), części zamienne oraz
                                        opiekę serwisową. Rozliczenie za papier
                                        leży po stronie Dzierżawcy.
                                    </p>
                                    <p>
                                        <strong className={t.textMain}>
                                            3. Gwarancja Ciągłości (SLA)
                                        </strong>
                                        <br />
                                        Zapewniamy wsparcie techniczne oraz
                                        regularne przeglądy konserwacyjne. W
                                        przypadku usterki, której nie da się
                                        usunąć u Klienta w określonym umową
                                        czasie SLA, PixelPrintShop bezpłatnie
                                        podstawia urządzenie zastępcze o nie
                                        gorszych parametrach roboczych.
                                    </p>
                                    <p>
                                        <strong className={t.textMain}>
                                            4. Zawarcie Umowy
                                        </strong>
                                        <br />
                                        Kalkulacje generowane przez aplikację na
                                        stronie mają charakter wyłącznie
                                        szacunkowy i nie stanowią oferty
                                        handlowej w rozumieniu art. 66 §1
                                        Kodeksu Cywilnego. Finalna umowa
                                        dzierżawy jest zawsze negocjowana i
                                        podpisywana indywidualnie.
                                    </p>
                                </>
                            )}

                            {legalModal === "rodo" && (
                                <>
                                    <p>
                                        <strong className={t.textMain}>
                                            Informacja o przetwarzaniu danych
                                            osobowych
                                        </strong>
                                    </p>
                                    <p>
                                        Zgodnie z art. 13 ust. 1 i ust. 2
                                        ogólnego rozporządzenia o ochronie
                                        danych osobowych z dnia 27 kwietnia 2016
                                        r. (RODO) informujemy, iż:
                                    </p>
                                    <ul className="list-disc pl-5 space-y-2">
                                        <li>
                                            Administratorem Twoich danych
                                            osobowych jest PixelPrintShop.
                                        </li>
                                        <li>
                                            Twoje dane osobowe przetwarzane będą
                                            w celu obsługi zapytania ofertowego,
                                            przedstawienia oferty na dzierżawę
                                            sprzętu drukującego oraz późniejszej
                                            realizacji umowy (na podstawie art.
                                            6 ust. 1 lit. b RODO).
                                        </li>
                                        <li>
                                            Odbiorcą Twoich danych mogą być
                                            wyłącznie podmioty wspierające
                                            obsługę informatyczną, firmy
                                            kurierskie dostarczające materiały
                                            eksploatacyjne oraz podmioty
                                            świadczące usługi księgowe na rzecz
                                            Administratora.
                                        </li>
                                        <li>
                                            Twoje dane nie będą przekazywane do
                                            państwa trzeciego ani organizacji
                                            międzynarodowej.
                                        </li>
                                        <li>
                                            Posiadasz prawo dostępu do treści
                                            swoich danych oraz prawo ich
                                            sprostowania, usunięcia,
                                            ograniczenia przetwarzania, prawo do
                                            przenoszenia danych, prawo
                                            wniesienia sprzeciwu.
                                        </li>
                                    </ul>
                                </>
                            )}
                        </div>

                        <button
                            onClick={() => setLegalModal(null)}
                            className={`w-full mt-10 py-4 bg-orange-500 text-white font-bold uppercase text-xs tracking-widest hover:bg-orange-400 transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-zinc-900`}
                        >
                            Akceptuję i zamykam
                        </button>
                    </div>
                </div>
            )}

            <footer
                className={`${t.bgSection} pt-20 pb-12 border-t ${t.border}`}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 lg:gap-8 mb-16">
                        <div className="md:col-span-2 lg:col-span-3">
                            <div className="flex items-center space-x-2 mb-6">
                                <BrandLogo className="w-8 h-8 mr-2" />
                                <span
                                    className={`font-heading font-black text-xl tracking-tighter uppercase ${t.textMain}`}
                                >
                                    PIXEL
                                    <span className="text-blue-600">PRINT</span>
                                    SHOP
                                </span>
                            </div>
                            <p
                                className={`${t.textSecondary} text-sm leading-relaxed mb-6 font-light max-w-sm`}
                            >
                                Nowoczesne systemy druku (MPS) dla biznesu.
                                Optymalizujemy koszty i zapewniamy bezawaryjność
                                na terenie całej Polski.
                            </p>

                            <div className="flex space-x-4 mb-6">
                                <a
                                    href="#facebook"
                                    aria-label="Profil PixelPrintShop na Facebooku"
                                    className={`w-10 h-10 rounded-full border ${t.border} flex items-center justify-center ${t.textSecondary} ${t.hoverTextMain} hover:border-blue-600 hover:bg-blue-600/10 transition-all focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                >
                                    <FacebookIcon className="w-4 h-4" />
                                </a>
                                <a
                                    href="#instagram"
                                    aria-label="Profil PixelPrintShop na Instagramie"
                                    className={`w-10 h-10 rounded-full border ${t.border} flex items-center justify-center ${t.textSecondary} ${t.hoverTextMain} hover:border-orange-500 hover:bg-orange-500/10 transition-all focus:outline-none focus:ring-2 focus:ring-orange-500`}
                                >
                                    <InstagramIcon className="w-4 h-4" />
                                </a>
                                <a
                                    href="#linkedin"
                                    aria-label="Profil PixelPrintShop na LinkedIn"
                                    className={`w-10 h-10 rounded-full border ${t.border} flex items-center justify-center ${t.textSecondary} ${t.hoverTextMain} hover:border-blue-500 hover:bg-blue-500/10 transition-all focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                >
                                    <LinkedinIcon className="w-4 h-4" />
                                </a>
                            </div>

                            <button
                                onClick={() => {
                                    setContactContext(null);
                                    setFormStatus("idle");
                                    setIsContactOpen(true);
                                }}
                                className="text-blue-500 text-xs font-bold uppercase tracking-widest hover:text-blue-400 transition-colors flex items-center focus:outline-none focus:underline"
                            >
                                Wyceń projekt{" "}
                                <ArrowRight
                                    className="ml-2 w-4 h-4"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>

                        <nav
                            aria-label="Szybkie linki - Oferta"
                            className="lg:col-span-1"
                        >
                            <h4
                                className={`font-heading ${t.textMain} font-bold text-xs uppercase tracking-[0.2em] mb-6`}
                            >
                                Oferta
                            </h4>
                            <ul className="space-y-4">
                                <li>
                                    <a
                                        href="#katalog"
                                        onClick={(e) =>
                                            scrollToSection(e, "katalog")
                                        }
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Katalog Maszyn
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="#kalkulator"
                                        onClick={(e) =>
                                            scrollToSection(e, "kalkulator")
                                        }
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Kalkulator Kosztów
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="#oprogramowanie"
                                        onClick={(e) =>
                                            scrollToSection(e, "oprogramowanie")
                                        }
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Oprogramowanie
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="#cennik"
                                        onClick={(e) =>
                                            scrollToSection(e, "cennik")
                                        }
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Modele Rozliczeń
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="#faq"
                                        onClick={(e) =>
                                            scrollToSection(e, "faq")
                                        }
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Baza Wiedzy (FAQ)
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <nav
                            aria-label="Szybkie linki - Legalne"
                            className="lg:col-span-1"
                        >
                            <h4
                                className={`font-heading ${t.textMain} font-bold text-xs uppercase tracking-[0.2em] mb-6`}
                            >
                                Legalne
                            </h4>
                            <ul className="space-y-4">
                                <li>
                                    <button
                                        onClick={() => setLegalModal("policy")}
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Polityka Prywatności
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => setLegalModal("terms")}
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Regulamin Świadczenia Usług
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => setLegalModal("rodo")}
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors focus:outline-none focus:underline`}
                                    >
                                        Informacja RODO
                                    </button>
                                </li>
                            </ul>
                        </nav>

                        <address className="lg:col-span-1 not-italic">
                            <h4
                                className={`font-heading ${t.textMain} font-bold text-xs uppercase tracking-[0.2em] mb-6`}
                            >
                                Kontakt
                            </h4>
                            <ul className="space-y-4">
                                <li className={`${t.textSecondary} text-sm`}>
                                    PixelPrintShop
                                </li>
                                <li>
                                    <a
                                        href="mailto:kontakt@pixelprintshop.pl"
                                        className={`block text-left ${t.textSecondary} hover:text-blue-500 text-sm transition-colors mt-2 focus:outline-none focus:underline`}
                                    >
                                        kontakt@pixelprintshop.pl
                                    </a>
                                </li>
                            </ul>
                        </address>
                    </div>

                    <div
                        className={`border-t ${t.border} pt-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-4 md:gap-0`}
                    >
                        <span
                            className={`text-[10px] font-bold uppercase tracking-[0.2em] ${t.textSecondary}`}
                        >
                            © {new Date().getFullYear()} PIXELPRINTSHOP.
                            Wszelkie prawa zastrzeżone.
                        </span>
                        <span
                            className={`text-[10px] font-bold uppercase tracking-[0.2em] ${t.textSecondary} mt-4 md:mt-0`}
                        >
                            Zaprojektowane i zbudowane przez{" "}
                            <a
                                href="https://sitexo.pl"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:text-blue-400 transition-colors focus:outline-none focus:underline"
                            >
                                siteXO.pl
                            </a>
                        </span>
                    </div>
                </div>
            </footer>
        </div>
    );
}
